import { _MustMatchServerStrings, AccessGuids, AlertClassColour, ApplicationNames, ConfigSystemParams, ErrorStrings, modalFormValues, msSize, OurColors, StatementLogoAcceptTypes, SystemLocks, TypeCompany, TypeCompanyFile } from 'src/app/core/consts';
import { AccountManagersService } from 'src/app/core/services/utelize/system/account-manager/account-managers-service';
import { AddressDTO } from 'src/app/core/models/system/mapping/address.dto';
import { AddressesService } from 'src/app/core/services/utelize/system/mapping/addresses-service';
import { AddressModalFormComponent } from '../../address-modal-form/address-modal-form.component';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AlertModalEditFormComponent } from '../../alert-modal-edit-form/alert-modal-edit-form.component';
import { AlertsModalFormComponent } from '../../alerts-modal-form/alerts-modal-form.component';
import { AlertsService } from 'src/app/core/services/utelize/system/alert/alerts-service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, debounceTime, forkJoin, Observable, of, Subscription, switchMap, take, throwError } from 'rxjs';
import { ChildCreditLimitBreachDTO } from 'src/app/core/models/system/company/child-credit-limit-breach.dto';
import { ChildrenCreditLimitBreachRequestDTO } from 'src/app/core/models/system/company/children-credit-limit-breach-request.dto';
import { CommunicationComposeModalFormComponent } from '../../_communication/communication-compose-modal-form/communication-compose-modal-form.component';
import { CommunicationModalFormComponent } from '../../_communication/communication-modal-form/communication-modal-form.component';
import { CommConfigService } from 'src/app/core/services/utelize/system/communication/comm-config-service';
import { CommunicationTemplateReplacements } from 'src/app/core/models/system/communication/communication-template-replacements';
import { CommunicationTemplatesDefaultsDTO } from 'src/app/core/models/system/communication/communication-templates-defaults.dto';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompanyDTO } from 'src/app/core/models/system/company/company.dto';
import { CompanyUsageLimitDTO } from 'src/app/core/models/system/company/company-usage-limit.dto';
import { CompletedModalFormComponent } from '../../_pop-ups/completed-modal-form/completed-modal-form.component';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ConfirmationModalFormComponent } from '../../_pop-ups/confirmation-modal-form/confirmation-modal-form.component';
import { CountriesService } from 'src/app/core/services/utelize/system/mapping/countries-service';
import { DatePipe } from '@angular/common';
import { DeliveryType, EspTypeSupportPlan, eUser, LimitType, MessageType } from 'src/app/core/enums';
import { DropdownAlertDefaultTemplateComponent } from 'src/app/core/dropdowns/alert-default-templates/dropdown-alert-default-template.component';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FileService } from 'src/app/core/services/utelize/general/file-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Guid } from 'guid-typescript';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { InformationModalFormComponent } from '../../_pop-ups/information-modal-form/information-modal-form.component';
import { InviewCompaniesService } from 'src/app/core/services/utelize/inview/inview-companies-service';
import { InviewCompanyDTO } from 'src/app/core/models/inview/inview-company.dto';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { LicencesCompanyAllocatedCardsComponent } from '../../_licence/licences-company-allocated/licences-company-allocated-cards/licences-company-allocated-cards.component';
import { LicencesCompanyAllocatedService } from 'src/app/core/services/utelize/system/licence/licences-company-allocated-service';
import { LicencesCompanyVisibleModalFormSearchComponent } from '../../_licence/licences-company-visible/licences-company-visible-modal-form-search/licences-company-visible-modal-form-search.component';
import { LocationAwarenessService } from 'src/app/core/services/utelize/system/location-awareness/location-awareness-service';
import { MapSimLocationsComponent } from 'src/app/shared/widget-no-formsmodalmodule/map-sim-locations/map-sim-locations.component';
import { MdmAccessService } from 'src/app/core/services/utelize/access/device-management/mdm-access.service';
import { MdmIntuneService } from 'src/app/core/services/utelize/system/device-management/mdm-intune-service';
import { NgbModal, NgbModalRef, NgbNav, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { SystemLockDTO } from 'src/app/core/models/system/system-lock/system-lock.dto';
import { SystemLockService } from 'src/app/core/services/utelize/system/system-lock/system-lock-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TemplateSMSModalFormComponent } from 'src/app/forms-modal/template-sms-modal-form/template-sms-modal-form.component';
import { TypesCompanyFileService } from 'src/app/core/services/utelize/system/type/types-company-file-service';
import { TypesCompanyService } from 'src/app/core/services/utelize/system/type/types-company-service';
import { TypesCurrencyService } from 'src/app/core/services/utelize/system/type/types-currency-service';
import { TypesCurrencySymbolService } from 'src/app/core/services/utelize/system/type/types-currency-symbol-service';
import { TypesPaymentService } from 'src/app/core/services/utelize/system/type/types-payment-service';
import { TypesPaymentTermService } from 'src/app/core/services/utelize/system/type/types-payment-term-service';
import { TypesSupportPlanService } from 'src/app/core/services/utelize/system/type/types-support-plan-service';
import { TypeSupportPlanDTO } from 'src/app/core/models/system/type/type-support-plan.dto';
import { UserDTO } from 'src/app/core/models/system/user/user.dto';
import { UserModalFormComponent } from '../../_user/user-modal-form/user-modal-form.component';
import { UsersAllEmbeddedComponent } from 'src/app/pages-embedded/users-all/users-all.component';
import { UsersPortalEmbeddedComponent } from 'src/app/pages-embedded/users-portal/users-portal.component';
import { ValidatorService } from 'src/app/core/services/utelize/general/validator-service';
import { WarningModalFormComponent } from '../../_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-company-modal-form',
  templateUrl: './company-modal-form.component.html',
  styleUrls: ['./company-modal-form.component.scss']
})

export class CompanyModalFormComponent implements AfterViewInit, OnDestroy, OnInit {
  
  @Input() forceCreateNewCompany: boolean | undefined;
  @Input() inputInviewCompanyId : number  | undefined;
  
  @Output() companyFormCancelled          : EventEmitter<void> = new EventEmitter<void>();
  @Output() iccidClicked                  : EventEmitter<any>  = new EventEmitter<any>();
  @Output() inviewCompanyDataHasBeenSaved : EventEmitter<any>  = new EventEmitter<any>();
  @Output() sureSimCompanyDataHasBeenSaved: EventEmitter<any>  = new EventEmitter<any>();
  
  @ViewChild('addressModalForm',              { static: false }) addressModalForm!             : AddressModalFormComponent;
  @ViewChild('alertdefaulttemplate',          { static: false }) alertdefaulttemplate!         : DropdownAlertDefaultTemplateComponent;
  @ViewChild('alertModalForm',                { static: false }) alertModalForm!               : AlertModalEditFormComponent;
  @ViewChild('alertsForm',                    { static: false }) alertsForm!                   : AlertsModalFormComponent;
  @ViewChild('ArrowNgbNav'                                     ) arrowNav!                     : NgbNav;
  @ViewChild('ceaseCompanyConfirmModal',      { static: false }) ceaseCompanyConfirmModal!     : ConfirmationModalFormComponent;
  @ViewChild('ceaseCompletedModalForm',       { static: false }) ceaseCompletedModalForm!      : CompletedModalFormComponent;
  @ViewChild('communicationComposeModalForm', { static: false }) communicationComposeModalForm!: CommunicationComposeModalFormComponent;
  @ViewChild('communicationModalForm',        { static: false }) communicationModalForm!       : CommunicationModalFormComponent;
  @ViewChild('companyModalForm',              { static: false }) companyModalForm!             : TemplateRef<void>;
  @ViewChild('completedModalForm',            { static: false }) completedModalForm!           : CompletedModalFormComponent;
  @ViewChild('informationModalForm',          { static: false }) informationModalForm!         : InformationModalFormComponent;
  @ViewChild('licenceCards',                  { static: false }) licenceCards!                 : LicencesCompanyAllocatedCardsComponent;
  @ViewChild('locationConsentTemplateForm',   { static: false }) locationConsentTemplateForm!  : TemplateSMSModalFormComponent;
  @ViewChild('mapSimLocations',               { static: false }) mapSimLocations!              : MapSimLocationsComponent;
  //@ViewChild('unceaseCompanyConfirmModal',    { static: false }) unceaseCompanyConfirmModal!   : ConfirmationModalFormComponent; //CRN_20261021 - Retired
  @ViewChild('userModalForm',                 { static: false }) userModalForm!                : UserModalFormComponent;
  @ViewChild('usersAllRef'                                     ) usersAllComponent!            : UsersAllEmbeddedComponent;
  @ViewChild('usersPortalRef'                                  ) usersPortalComponent!         : UsersPortalEmbeddedComponent;
  @ViewChild('visibleLicencesSearchForm',     { static: false }) visibleLicencesSearchForm!    : LicencesCompanyVisibleModalFormSearchComponent;
  @ViewChild('warningModalForm',              { static: false }) warningModalForm!             : WarningModalFormComponent;
  
  get canChangeCeasedState() { return !this.newCompany
                                      && !this.ceaseInProgress
                                      && this.sureSimCompanyId!=undefined
                                      && this.sureSimCompanyId>0
                                      && this.sureSimCompanyId!==this.curUser?.companyId                                      ; }
  get ceaseBlockedBySims  () { return this.sureSimCompany?.hasActiveSim===true                                                ; }
  get ceaseBlockedHint    () { const count: number=this.sureSimCompany?.activeSimCount ?? 0;
                               return !this.ceaseBlockedBySims
                                      ? ""
                                      : (count>0 ? count + (count===1 ? " SIM" : " SIMs") : "SIMs")
                                        + " in this company's hierarchy "
                                        + (count===1 ? "is" : "are")
                                        + " still live. Cease "
                                        + (count===1 ? "it" : "them")
                                        + " in Manage SIM before ceasing the company."                                        ; }
  get isCompanyFormOpen   () { return this._isCompanyFormOpen                                                                 ; }
  get showAccountManager  () { return this.showSupportPlan && (this.selectedSupportPlanTier==EspTypeSupportPlan.Business
                                                               || this.selectedSupportPlanTier==EspTypeSupportPlan.Enterprise); }
  get showLocationServices() { return this.featureEnabledLocationServices                                                     ; }

  get canCeaseCompany      () { return this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCompanyCease,             true)
                                       && this.canChangeCeasedState
                                       && this.sureSimCompany?.ceased===false
                                       && !this.formIsLocked                                                                        ; }
  //CRN_20261021 - Retired
  // get canUnceaseCompany    () { return this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCompanyUncease,           true)
  //                                      && this.canChangeCeasedState
  //                                      && this.sureSimCompany?.ceased===true
  //                                      && !this.lockedByAnotherUser                                                                 ; }
  get canRepeatCease       () { return this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCompanyCease,             true)
                                       && this.canChangeCeasedState
                                       && this.sureSimCompany?.ceased===true
                                       && this.sureSimCompany?.ceaseIncomplete===true
                                       && !this.lockedByAnotherUser                                                                 ; }

  get showDropdownShowAtTop() { return this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCompanyDropdownShowAtTop, true); }
  get showMdmDesensitise   () { return this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCompanyDesensitiseMdm,    true); }
  get showStatementLogo    () { return this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCompanyStatementLogo,     true); }
  
  get modalBackGround         () { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE"            );
                                   return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false)                   }
  get tabTitleAlerts          () { return this.configSystemService.getValue(ConfigSystemParams.FormCompanyTabTitleAlerts,           "Alerts"           ); }
  get tabTitleBasic           () { return this.configSystemService.getValue(ConfigSystemParams.FormCompanyTabTitleBasicDetails,     "Basic Details"    ); }
  get tabTitleDeviceManagement() { return this.configSystemService.getValue(ConfigSystemParams.FormCompanyTabTitleDeviceManagement, "Device Management"); }
  get tabTitleInvoice         () { return this.configSystemService.getValue(ConfigSystemParams.FormCompanyTabTitleInvoice,          "Invoice"          ); }
  get tabTitleLicencing       () { return this.configSystemService.getValue(ConfigSystemParams.FormCompanyTabTitleLicencing,        "Licencing"        ); }
  get tabTitlePortal          () { return this.configSystemService.getValue(ConfigSystemParams.FormCompanyTabTitlePortal,           "Portal"           ); }
  get tabTitleSingleSignOn    () { return this.configSystemService.getValue(ConfigSystemParams.FormCompanyTabTitleSingleSignOn,     "Single Sign-on"   ); }
  get tabTitleSpendLimits     () { return this.configSystemService.getValue(ConfigSystemParams.FormCompanyTabTitleSpendLimits,      "Spend Limits"     ); }
  get tabTitleSupport         () { return this.configSystemService.getValue(ConfigSystemParams.FormCompanyTabTitleSupport,          "Support"          ); }
  get tabTitleTariffs         () { return this.configSystemService.getValue(ConfigSystemParams.FormCompanyTabTitleTariffs,          "Tariffs"          ); }

  get autofill                   () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyAutofill,                    false); }
  get creditLimitsEnabled        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.CreditLimitsCompanyEnabled,             false); }
  get enableAlertsOnNew          () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyEnableAlertsOnNew,           false); }
  get enableLicenceDetailsOnNew  () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyEnableLicenceDetailsOnNew,   false); }
  get mandatoryAccountRef        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyAccountRefMandatory,         true ); }
  get mandatoryAddress           () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyAddressMandatory,            true ); }
  get mandatoryCompanyRegNo      () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyRegNoMandatory,              true ); }
  get mandatoryVATNumber         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyVATNumberMandatory,          true ); }
  get requireSsoTenantIdMicrosoft() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyRequireSsoTenantIdMicrosoft, true ); }
  get showAlerts                 () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyShowAlerts,                  false)&&
                                             this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCompanyShowAlerts                            ); }
  get showBillingOnly            () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyShowBillingOnly,             true ); }
  get showCompanyDataLimit       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyUsageLimitsShowDataLimit,    true ); }
  get showCompanyNoLimit         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyUsageLimitsShowNoLimit,      true ); }
  get showCompanyTabIcons        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowCompanyTabIcons,                    true ); }
  get showInventoryOrgId         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.InventoryEnabled,                       false)
                                             && this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCompanyInventoryOrgId,               true ); }
  get showInvoiceDetails         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyShowInvoiceDetails,          false); }
  get showDeviceManagement       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyShowDeviceManagement,        false)&&
                                             this.configSystemService.getValueAsBoolean(ConfigSystemParams.DeviceManagementIntune,                 false)&&
                                             this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCompanyShowDeviceManagement                  ); }
  get showLicenceDetails         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyShowLicenceDetails,          false)&&
                                             this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCompanyShowLicenceDetails                    ); }
  get showPortalDetails          () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyShowPortalDetails,           false); }
  get showSingleSignOn           () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyShowSingleSignOn,            false)&&
                                             this.configSystemService.getValueAsBoolean(ConfigSystemParams.SingleSignOnMicrosoft,                  false)&&
                                             this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCompanyShowSingleSignOn                      ); }
  get showSpendLimits            () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyShowSpendLimits,             false)&&
                                             this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCompanyShowSpendLimits                       ); }
  get showSupport                () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowSupport,                            true ); }
  get showSupportPlan            () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SupportPlansEnabled,                    false); }
  get showTariffAndPricing       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyShowTariffAndPricing,        false); }
  get submitEnableOnEdit         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanySubmitEnableOnEdit,          true ); }
  get systemLocksEnabled         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SystemLocksEnabled,                     true ); }
  get systemLocksShowDetails     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SystemLocksShowDetails,                 true ); }
  get systemLocksShowWarningModal() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SystemLocksShowWarningModal,            true ); }
  
  private accountManagerIdData!              : IdAndDescriptionDTO[];
  private addressModalFormIsOpen             : boolean=false;
  private alertDefaultTemplatesIdData!       : IdAndDescriptionDTO[];
  private canCreateSubCompaniesCompanyTypeIds: number[]=[];
  private communicationModalFormIsOpen       : boolean=false;
  private companyAddress                     : AddressDTO | undefined;
  private companyFileTypeId                  : number | undefined;
  private companyModalFormRef!               : NgbModalRef;
  private companyTypeIdData!                 : IdAndDescriptionDTO[];
  private countryIdData!                     : IdAndDescriptionDTO[];
  private editingCompanyAddress              : boolean=false;
  private formChangesSubscription?           : Subscription;
  private initialStatus                      : string="Please complete the following details";
  private inviewCompanyCreated               : boolean=false;
  private inviewCompanyIdData!               : InviewCompanyDTO[];
  private inviewParentCompanyIdData!         : IdAndDescriptionDTO[];
  private invoiceDetails_CurrencyIdData!     : IdAndDescriptionDTO[];
  private invoiceDetails_PaymentMethodIdData!: IdAndDescriptionDTO[];
  private invoiceDetails_PaymentTermIdData!  : IdAndDescriptionDTO[];
  private _isCompanyFormOpen                 : boolean=false;
  private licencesGridTitleAllocated         : string="Allocated Licences";
  private licencesGridTitleVisible           : string="Allowed Licences";
  private lockedByAnotherUser                : boolean=false;
  private logoFile                           : File | null=null;
  private openAtNavItem                      : number | undefined;
  private parentCompanyCreditLimit           : number | null=null;
  private selectedInviewCompany?             : InviewCompanyDTO;
  private selectedInviewParentCompany?       : IdAndDescriptionDTO;
  private statementLogoFile                  : File | null=null;
  private statementLogoFileTypeId            : number | undefined;
  private supportPlanIdData!                 : IdAndDescriptionDTO[];
  private supportPlans                       : TypeSupportPlanDTO[]=[];
  private sureSimParentCompanyId             : number | undefined;
  private systemLockId                       : number | undefined;
  private usageLimits_currencyIdData!        : IdAndDescriptionDTO[];
  private userModalFormIsOpen                : boolean=false;
  private visibleLicencesSearchFormIsOpen    : boolean=false;
  
  public activeId                      : number=1;
  public alertColourProgress           : string=AlertClassColour.Grey;
  public alertGroupId                  : number=1;
  public basicDetailsForm!             : UntypedFormGroup;
  public billingAddressAsCompany       : boolean=false;
  public billingAddressId              : null | number | undefined=null;
  public billingRecipientsFilterExpr   : any;
  public ceaseInProgress               : boolean=false;
  public creditLimitEnabled            : boolean=false;
  public companyAddressId              : null | number | undefined=null;
  public companyForm!                  : UntypedFormGroup;
  public companyFormSubmitted          : boolean=false;
  public createNewCompanySelected      : boolean=false;
  public curUser                       : SystemUserDTO;
  public curUserIsUtelize              : boolean;
  public featureEnabledCountryPlans    : boolean=false;
  public featureEnabledLocationServices: boolean=false;
  public featureEnabledLocationWebhook : boolean=false;
  public featureEnabledMdm             : boolean=false;
  public featureEnabledSso             : boolean=false;
  public fileLockHoverText             : string | undefined;
  public formIsLocked                  : boolean=false;
  public formTitle                     : string="Company";
  public haveLogoFromDatabase          : boolean=false;
  public haveLogoToUpload              : boolean=false;
  public haveStatementLogoFromDatabase : boolean=false;
  public haveStatementLogoToUpload     : boolean=false;
  public inviewCompanySelected         : boolean=false;
  public inviewParentCompanySelected   : boolean=false;
  public invoiceDetailsForm!           : UntypedFormGroup;
  public isRequired                    = (path: string) => this.validatorService.isRequired(this.companyForm, path, this.newCompany);
  public licenceDetailsForm!           : UntypedFormGroup;
  public licencesAllowedShowing        : boolean=false;
  public licencesGridTitle             : string=this.licencesGridTitleAllocated;
  public LimitType                     = LimitType;
  public logoFileUrl                   : string | null=null;
  public mdmControlsShowMicrosoft      : boolean=false;
  public mdmForm!                      : UntypedFormGroup;
  public mdmTestConnectionResult       : boolean | undefined;
  public newCompany                    : boolean=false;
  public portalDetailsForm!            : UntypedFormGroup;
  public statementLogoAcceptTypes      : string=StatementLogoAcceptTypes;
  public statementLogoFileUrl          : string | null=null;
  public progressInformation           : string=this.initialStatus;
  public selectCountryId               : number | undefined;
  public selectedAlertTemplateId       : number=0;
  public selectedLimitType             : number=LimitType.Spend;
  public showComposeForm               : boolean=false;
  public showMessageIcon               : boolean=false;
  public ssoControlsShowMicrosoft      : boolean=false;
  public ssoForm!                      : UntypedFormGroup;
  public submitButtonEnabled           : boolean=false;
  public sureSimCompany                : CompanyDTO | undefined;
  public sureSimCompanyId              : number | undefined;
  public testAccountChkBxKeepVisible   : boolean=false;
  public usageLimitsForm!              : UntypedFormGroup;
  public userCanCreateTestAccounts     : boolean=false;
  public warningMessageMain            : string | undefined;
  public warningMessageSub             : string | undefined;

  public get companyCurrencySymbol(): string {
    try {
      const currencyId=this.invoiceDetailsForm?.get("invoiceDetails_CurrencyId")?.value;

      if (currencyId==null || currencyId==="")
        return "";

      const currency=this.typesCurrencyService.allCurrencyTypes?.find(c => c.id===currencyId);

      if (!currency)
        return "";

      const symbolType=this.typesCurrencySymbolService.allCurrencySymbolTypes?.find(s => s.id===currency.currencySymbolID);

      return symbolType?.currencySymbolType ?? currency.currencyCode;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  //#region NavItems

  public navItemBasicDetails    : number=1;
  public navItemDeviceManagement: number=2;
  public navItemInvoiceDetails  : number=3;
  public navItemTariffPricing   : number=4;
  public navItemPortalDetails   : number=5;
  public navItemLicenceDetails  : number=6;
  public navItemUsageLimits     : number=7;
  public navItemSingleSignOn    : number=8;
  public navItemCompanyAlerts   : number=9;
  public navItemSupport         : number=10;
  public navItemLocationServices: number=11;

  //#endregion

  //#region for Validators etc.
  
  private inviewAddressMaxLength: number=500;
  public accountRefMaxLength    : number=30;
  public companynameMaxLength   : number=200;
  public domainMaxLength        : number=253;
  public regnoMaxLength         : number=8;
  public vatnoMaxLength         : number=10;

  //#endregion 

  constructor(
    private accountManagersService         : AccountManagersService,
    private addressesService               : AddressesService,
    private alertService                   : AlertsService,
    private authenticationService          : AuthenticationService,
    private changeDetectorRef              : ChangeDetectorRef,
    private commConfigService              : CommConfigService,
    private companiesService               : CompaniesService,
    private componentAccessUserService     : ComponentAccessUserService,
    private configSystemService            : ConfigSystemService,
    private countriesService               : CountriesService,
    private datePipe                       : DatePipe,
    private exceptionsService              : ExceptionsService,
    private fileService                    : FileService,
    private formBuilder                    : UntypedFormBuilder,
    private inviewCompaniesService         : InviewCompaniesService,
    private lastPassKillerService          : LastPassKillerService,
    private licencesCompanyAllocatedService: LicencesCompanyAllocatedService,
    private locationAwarenessService       : LocationAwarenessService,
    private mdmAccessService               : MdmAccessService,
    private mdmIntuneService               : MdmIntuneService,
    private modalService                   : NgbModal,
    private systemLockService              : SystemLockService,
    private typesCompanyFileService        : TypesCompanyFileService,
    private typesCompanyService            : TypesCompanyService,
    private typesCurrencyService           : TypesCurrencyService,
    private typesCurrencySymbolService     : TypesCurrencySymbolService,
    private typesPaymentService            : TypesPaymentService,
    private typesPaymentTermService        : TypesPaymentTermService,
    private typesSupportPlanService        : TypesSupportPlanService,
    private validatorService               : ValidatorService
  ) {
    this.curUser         =this.authenticationService.currentUserObject();
    this.curUserIsUtelize=this.curUser.isUtelize;
  }

  public ngOnInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
      
      if (this.formChangesSubscription) {
        this.formChangesSubscription.unsubscribe();
        this.formChangesSubscription=undefined;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetMainVariables(): void {
    try {
      this.activeId                           =this.navItemBasicDetails;
      this.alertColourProgress                =AlertClassColour.Grey;
      this.billingAddressAsCompany            =false;
      this.billingAddressId                   =undefined;
      this.billingRecipientsFilterExpr        =this.showBillingOnly ? ['sendBill', '=', true] : null;
      this.canCreateSubCompaniesCompanyTypeIds=[];
      this.communicationModalFormIsOpen       =false;
      this.companyAddress                     =undefined;
      this.companyAddressId                   =undefined;
      this.companyFormSubmitted               =false;
      this.createNewCompanySelected           =false;
      this.featureEnabledCountryPlans         =false;
      this.featureEnabledLocationServices     =false;
      this.featureEnabledLocationWebhook      =false;
      this.featureEnabledMdm                  =false;
      this.featureEnabledSso                  =false;
      this.haveLogoFromDatabase               =false;
      this.haveLogoToUpload                   =false;
      this.haveStatementLogoFromDatabase      =false;
      this.haveStatementLogoToUpload          =false;
      this.inviewCompanyCreated               =false;
      this.inviewCompanySelected              =false;
      this.inviewParentCompanySelected        =false;
      this.licencesAllowedShowing             =false;
      this.licencesGridTitle                  =this.licencesGridTitleAllocated;
      this.logoFile                           =null;
      this.logoFileUrl                        =null;
      this.mdmTestConnectionResult            =undefined;
      this.progressInformation                =this.initialStatus;
      this.selectCountryId                    =undefined;
      this.selectedLimitType                  =LimitType.Spend;
      this.showMessageIcon                    =this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyShowMessageIcon);
      this.statementLogoFile                  =null;
      this.statementLogoFileUrl               =null;
      this.submitButtonEnabled                =false;
      this.sureSimCompany                     =undefined;
      this.sureSimCompanyId                   =0;
      this.testAccountChkBxKeepVisible        =false;
      this.userCanCreateTestAccounts          =this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCompanyCreateTestAccounts);

      this.getIdsForCompanyTypes();
      this.getIdForCompanyFileTypeLogo();
      // this.setOrClearLogoFileValidators(false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(sureSimCompanyId: number | undefined, openAtLocation: boolean = false): void {
    try {
      this.ceaseInProgress    =false;
      this.fileLockHoverText  ="Company is being edited by another";
      this.formIsLocked       =false;
      this.lockedByAnotherUser=false;
      this.systemLockId       =undefined;

      this.resetMainVariables();

      if (openAtLocation) {
        this.featureEnabledLocationServices=true;
        this.openAtNavItem                 =this.navItemLocationServices;
      }
      this.refreshAlertDefaultTemplateData();
      this.refreshCompanyTypeData();
      this.refreshCountryData();
      this.refreshInvoiceDetailsCurrencyData();
      this.refreshPaymentMethodData();
      this.refreshPaymentTermData();
      this.refreshUsageLimitsCurrencyData();
      
      if (this.showSupportPlan) {
        this.refreshSupportPlanData();
        this.refreshAccountManagerData();
      }

      this.countriesService.refreshCountriesValues();
      this.typesCurrencyService.refreshCurrencyTypeValues();
      this.typesCurrencySymbolService.refreshCurrencyTypeValues();

      if (sureSimCompanyId != undefined && <number>sureSimCompanyId>0) {
        this.formTitle       ="Manage Company";
        this.newCompany      =false;
        this.sureSimCompanyId=sureSimCompanyId;
        
        this.setUpForm();
        this.enableDisableControls(!this.submitEnableOnEdit);
        this.processSystemLock();
        this.getSureSimCompanyAndOpenModal();
      } else {
        this.formTitle       ="Create Company";
        this.newCompany      =true;
        this.sureSimCompanyId=0;

        this.refreshInviewCompanyData();
        this.refreshInviewParentCompanyData();
        this.setUpForm();
        this.enableDisableControls(false);
        this.openModal();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openFormAtCreditLimit(sureSimCompanyId: number): void {
    try {
      this.openAtNavItem=this.navItemInvoiceDetails;
      
      this.openForm(sureSimCompanyId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.companyModalFormRef=this.modalService.open(this.companyModalForm, { backdrop: this.modalBackGround,
                                                                               centered: true,
                                                                               keyboard: false,
                                                                               size    : msSize.Large });
      this._isCompanyFormOpen=true;
      this.companyModalFormRef.result.then(
        () => { this._isCompanyFormOpen=false; },
        () => { this._isCompanyFormOpen=false; }
      );

      setTimeout(() => this.updateSubmitButtonAppearance());
    }
    catch(e) {
      this.companyFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private updateSubmitButtonAppearance(): void {
    try {
      const btn=document.getElementById("add-btn");
      
      if (!btn)
        return;
  
      btn.classList.remove("btn-success","btn-danger");
  
      const shouldBeGreen=this.submitButtonEnabled || this.newCompany;

      btn.classList.add(shouldBeGreen ? "btn-success" : "btn-danger");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }


  //#region companyForm

  get formOfBasicDetails() {
    return this.basicDetailsForm.controls;
  }

  get formOfInvoiceDetails() {
    return this.invoiceDetailsForm.controls;
  }

  get formOfLicenceDetails() {
    return this.licenceDetailsForm.controls;
  }
  
  get formOfMdm() {
    return this.mdmForm.controls;
  }

  get formOfPortalDetails() {
    return this.portalDetailsForm.controls;
  }
  
  get formOfSso() {
    return this.ssoForm.controls;
  }
  
  get formOfUsageLimits() {
    return this.usageLimitsForm.controls;
  }
  
  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.basicDetailsForm);
      this.removeFormFields(this.invoiceDetailsForm);
      this.removeFormFields(this.licenceDetailsForm);
      this.removeFormFields(this.mdmForm);
      this.removeFormFields(this.portalDetailsForm);
      this.removeFormFields(this.ssoForm);
      this.removeFormFields(this.usageLimitsForm);
      //Remove companyForm fields last
      this.removeFormFields(this.companyForm);

      this.basicDetailsForm  =this.formBuilder.group({ });
      this.companyForm       =this.formBuilder.group({ });
      this.invoiceDetailsForm=this.formBuilder.group({ });
      this.licenceDetailsForm=this.formBuilder.group({ });
      this.mdmForm           =this.formBuilder.group({ });
      this.portalDetailsForm =this.formBuilder.group({ });
      this.ssoForm           =this.formBuilder.group({ });
      this.usageLimitsForm   =this.formBuilder.group({ });
      
      this.addFormFields(this.basicDetailsForm);
      this.addFormFields(this.invoiceDetailsForm);
      this.addFormFields(this.licenceDetailsForm);
      this.addFormFields(this.mdmForm);
      this.addFormFields(this.portalDetailsForm);
      this.addFormFields(this.ssoForm);
      this.addFormFields(this.usageLimitsForm);
      
      this.companyForm.addControl("basicDetailsForm",   this.basicDetailsForm);
      this.companyForm.addControl("invoiceDetailsForm", this.invoiceDetailsForm);
      this.companyForm.addControl("licenceDetailsForm", this.licenceDetailsForm);
      this.companyForm.addControl("mdmForm",            this.mdmForm);
      this.companyForm.addControl("portalDetailsForm",  this.portalDetailsForm);
      this.companyForm.addControl("ssoForm",            this.ssoForm);
      this.companyForm.addControl("usageLimitsForm",    this.usageLimitsForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      //CRN_20250618 - ⚠️ WARNING Validators may also be set in setOrClearValidatorsForTestMode() ⚠️
      //---------------------------------------------------------------------------------------------

      if (formGroup==this.basicDetailsForm) {
        this.addFormControl(formGroup, "accountManagerId",      "",    []);
        this.addFormControl(formGroup, "active",                true,  []);
        this.addFormControl(formGroup, "asCompanyAddress",      false, []);
        this.addFormControl(formGroup, "companyname",           "",    [Validators.required, Validators.maxLength(this.companynameMaxLength)]);
        this.addFormControl(formGroup, "companyTypeId",         "",    [Validators.required]);
        this.addFormControl(formGroup, "countryId",             "",    [Validators.required]);
        this.addFormControl(formGroup, "domain",                "",    [Validators.required, Validators.maxLength(this.domainMaxLength)]);
        this.addFormControl(formGroup, "dropdownShowAtTop",     false, []);
        this.addFormControl(formGroup, "inventoryOrgId",        "",    this.showInventoryOrgId ? [Validators.min(1), Validators.pattern(/^[0-9]+$/)] : []);
        this.addFormControl(formGroup, "inviewCompanyId",       "",    [Validators.required]);
        this.addFormControl(formGroup, "inviewParentCompanyId", "",    [Validators.required]);
        // this.addFormControl(formGroup, "postcodeLookupCompany", "",    []);
        // this.addFormControl(formGroup, "postcodeLookupBilling", "",    []);
        this.addFormControl(formGroup, "regno",                 "",    [Validators.required, Validators.maxLength(this.regnoMaxLength)]);
        this.addFormControl(formGroup, "supportPlanId",         "",    []);
        this.addFormControl(formGroup, "testAccount",           false, []);
        this.addFormControl(formGroup, "vatno",                 "",    [Validators.required, Validators.maxLength(this.vatnoMaxLength)]);

        this.addFormControl(formGroup, "companyAddrCountryId",  "",    []);
        this.addFormControl(formGroup, "companyAddrCounty",     "",    []);
        this.addFormControl(formGroup, "companyAddrLine1",      "",    []);
        this.addFormControl(formGroup, "companyAddrLine2",      "",    []);
        this.addFormControl(formGroup, "companyAddrLine3",      "",    []);
        this.addFormControl(formGroup, "companyAddrPostCode",   "",    []);
        this.addFormControl(formGroup, "companyAddrTownOrCity", "",    []);

        this.addFormControl(formGroup, "billingAddrCountryId",  "",    []);
        this.addFormControl(formGroup, "billingAddrCounty",     "",    []);
        this.addFormControl(formGroup, "billingAddrLine1",      "",    []);
        this.addFormControl(formGroup, "billingAddrLine2",      "",    []);
        this.addFormControl(formGroup, "billingAddrLine3",      "",    []);
        this.addFormControl(formGroup, "billingAddrPostCode",   "",    []);
        this.addFormControl(formGroup, "billingAddrTownOrCity", "",    []);
        
        if (!this.newCompany) {
          this.basicDetailsForm.controls["companyname"].disable();
          this.basicDetailsForm.get("inviewCompanyId")?.clearValidators();
          this.basicDetailsForm.get("inviewCompanyId")?.updateValueAndValidity();
          this.basicDetailsForm.get("inviewParentCompanyId")?.clearValidators();
          this.basicDetailsForm.get("inviewParentCompanyId")?.updateValueAndValidity();
        }

        if (!this.mandatoryCompanyRegNo) {
          this.basicDetailsForm.get("regno")?.clearValidators();
          this.basicDetailsForm.get("regno")?.updateValueAndValidity();
        }

        if (!this.mandatoryVATNumber) {
          this.basicDetailsForm.get("vatno")?.clearValidators();
          this.basicDetailsForm.get("vatno")?.updateValueAndValidity();
        }

      } else if (formGroup==this.invoiceDetailsForm) {
        let invoice   : boolean=this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanySetInvoiceOnAdd);
        let statement : boolean=this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanySetStatementOnAdd);
        let billFormat: string=invoice ? "invoice" : (statement ? "statement" : "");//"none");
        
        this.addFormControl(formGroup, "invoiceDetails_AccountRef",              "",                   [Validators.required, Validators.maxLength(this.accountRefMaxLength)]);
        this.addFormControl(formGroup, "invoiceDetails_BillOnly",                this.showBillingOnly, []);
        this.addFormControl(formGroup, "invoiceDetails_billFormat",              billFormat,           []);
        this.addFormControl(formGroup, "invoiceDetails_creditLimit",             null,                 []);
        this.addFormControl(formGroup, "invoiceDetails_creditLimitEnabled",      false,                []);
        this.addFormControl(formGroup, "invoiceDetails_creditLimitExceedAction", null,                 []);
        this.addFormControl(formGroup, "invoiceDetails_currentCreditLimit",      null,                 []);
        this.addFormControl(formGroup, "invoiceDetails_CurrencyId",              "",                   [Validators.required]);
        // this.addFormControl(formGroup, "invoiceDetails_invoice",                 invoice,              []);
        // this.addFormControl(formGroup, "invoiceDetails_statement",               statement,            []);
        this.addFormControl(formGroup, "invoiceDetails_PaymentMethodId",         "",                   [Validators.required]);
        this.addFormControl(formGroup, "invoiceDetails_PaymentTermId",           "",                   [Validators.required]);

        if (!this.mandatoryAccountRef) {
          this.invoiceDetailsForm.get("invoiceDetails_AccountRef")?.clearValidators();
          this.invoiceDetailsForm.get("invoiceDetails_AccountRef")?.updateValueAndValidity();
        }
      
      } else if (formGroup==this.licenceDetailsForm) {
        this.addFormControl(formGroup, "licenceDetailsForm_visible", false, []);
        
      } else if (formGroup==this.mdmForm) {
        let mdmDesensitiseOnAdd: boolean=this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanySetMdmDesensitiseOnAdd, false);

        this.addFormControl(formGroup, "mdmForm_mdmDesensitise",           mdmDesensitiseOnAdd, []);
        this.addFormControl(formGroup, "mdmForm_mdmMicrosoft",             false,               []);
        this.addFormControl(formGroup, "mdmForm_mdmMicrosoftClientId",     undefined,           []);
        this.addFormControl(formGroup, "mdmForm_mdmMicrosoftClientSecret", undefined,           []);
        this.addFormControl(formGroup, "mdmForm_mdmMicrosoftTenantId",     undefined,           []);
        this.setOrClearMdmMicrosoftValidators(false);
        this.mdmControlsShowMicrosoft=false;
      
      } else if (formGroup==this.portalDetailsForm) {
        let createSubCompanies: boolean=false; //this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCompanySetCreateSubCompanyOnAdd);
        let portalAccess      : boolean=this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanySetPortalAccessOnAdd);
        
        this.addFormControl(formGroup, "portalDetails_Branding",           false,              []);
        this.addFormControl(formGroup, "portalDetails_CreateSubCompanies", createSubCompanies, []);
        // this.addFormControl(formGroup, "portalDetails_logoFileData",       undefined,          []);
        this.addFormControl(formGroup, "portalDetails_PortalAccess",       portalAccess,       []);
        
      } else if (formGroup==this.ssoForm) {
        this.addFormControl(formGroup, "ssoForm_ssoMicrosoft",         false,     []);
        this.addFormControl(formGroup, "ssoForm_ssoMicrosoftTenantId", undefined, []);
        this.setOrClearSsoMicrosoftTenantIdValidators(false);
        this.ssoControlsShowMicrosoft=false;
        
      } else if (formGroup==this.usageLimitsForm) {
        this.addFormControl(formGroup, "usageLimits_currencyId",    "",   []);
        this.addFormControl(formGroup, "usageLimits_dataLimit",     "",   []);
        this.addFormControl(formGroup, "usageLimits_dataLimitUnit", "MB", []);
        this.addFormControl(formGroup, "usageLimits_limit",         "",   []);
        this.addFormControl(formGroup, "usageLimits_selfAuth",      "",   []);
        this.updateLimitTypeValidators();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | null | number | string | undefined,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.basicDetailsForm && this.sureSimCompany != undefined) {
        this.basicDetailsForm.controls["accountManagerId"].setValue(this.sureSimCompany.accountManagerID ?? "");
        this.basicDetailsForm.controls["active"].setValue(this.sureSimCompany.active);
        this.basicDetailsForm.controls["asCompanyAddress"].setValue(this.billingAddressAsCompany);
        this.basicDetailsForm.controls["companyname"].setValue(this.sureSimCompany.companyName);
        this.basicDetailsForm.controls["companyTypeId"].setValue(this.sureSimCompany.companyTypeID);
        this.basicDetailsForm.controls["countryId"].setValue(this.sureSimCompany.countryID);
        this.basicDetailsForm.controls["domain"].setValue(this.sureSimCompany.domain);
        this.basicDetailsForm.controls["dropdownShowAtTop"].setValue(this.sureSimCompany.dropdownShowAtTop);
        this.basicDetailsForm.controls["inventoryOrgId"].setValue(this.sureSimCompany.inventoryOrgId ?? "");
        this.basicDetailsForm.controls["inviewCompanyId"].setValue(this.sureSimCompany.inviewCompanyID);
        this.basicDetailsForm.controls["regno"].setValue(this.sureSimCompany.regNo);
        this.basicDetailsForm.controls["supportPlanId"].setValue(this.sureSimCompany.supportPlanID ?? "");
        this.basicDetailsForm.controls["testAccount"].setValue(this.sureSimCompany.testAccount);
        this.basicDetailsForm.controls["vatno"].setValue(this.sureSimCompany.vatNo);

        this.applyAccountManagerVisibility();
        this.setOrClearValidatorsForTestMode(!this.sureSimCompany.testAccount, false);

      } else if (formGroup==this.invoiceDetailsForm && this.sureSimCompany != undefined) {
        this.invoiceDetailsForm.controls["invoiceDetails_AccountRef"].setValue(this.sureSimCompany.accountRef);
        this.invoiceDetailsForm.controls["invoiceDetails_billFormat"].setValue(this.sureSimCompany.invoice ? "invoice" : (this.sureSimCompany.statement ? "statement" : ""));//"none"));
        this.invoiceDetailsForm.controls["invoiceDetails_creditLimit"].setValue(this.sureSimCompany.creditLimit ?? null);
        this.invoiceDetailsForm.controls["invoiceDetails_creditLimitEnabled"].setValue(this.sureSimCompany.creditLimitEnabled ?? false);
        this.invoiceDetailsForm.controls["invoiceDetails_creditLimitExceedAction"].setValue(this.sureSimCompany.creditLimitExceedAction ?? null);
        this.invoiceDetailsForm.controls["invoiceDetails_currentCreditLimit"].setValue(this.sureSimCompany.currentCreditLimit ?? null);
        this.creditLimitEnabled=this.sureSimCompany.creditLimitEnabled ?? false;
        this.invoiceDetailsForm.controls["invoiceDetails_CurrencyId"].setValue(this.sureSimCompany.invoiceCurrencyID);
        // this.invoiceDetailsForm.controls["invoiceDetails_invoice"].setValue(this.sureSimCompany.invoice);
        // this.invoiceDetailsForm.controls["invoiceDetails_statement"].setValue(this.sureSimCompany.statement);
        this.invoiceDetailsForm.controls["invoiceDetails_PaymentMethodId"].setValue(this.sureSimCompany.paymentMethodID);
        this.invoiceDetailsForm.controls["invoiceDetails_PaymentTermId"].setValue(this.sureSimCompany.paymentTermID);
        this.loadParentCompanyCreditLimit();
        this.applyCreditLimitEditGuard();
        this.getCompanyStatementLogo();

      } else if (formGroup==this.licenceDetailsForm && this.sureSimCompany != undefined) {
        
      } else if (formGroup==this.mdmForm && this.sureSimCompany != undefined) {
        this.mdmForm.controls["mdmForm_mdmDesensitise"].setValue(this.sureSimCompany.mdmDesensitise);
        this.mdmForm.controls["mdmForm_mdmMicrosoft"].setValue(this.sureSimCompany.mdmMicrosoft);
        this.mdmForm.controls["mdmForm_mdmMicrosoftClientId"].setValue(this.sureSimCompany.mdmMicrosoftClientID);
        this.mdmForm.controls["mdmForm_mdmMicrosoftClientSecret"].setValue(this.sureSimCompany.mdmMicrosoftClientSecretEnc);
        this.mdmForm.controls["mdmForm_mdmMicrosoftTenantId"].setValue(this.sureSimCompany.mdmMicrosoftTenantID);
        this.setOrClearMdmMicrosoftValidators(this.sureSimCompany.mdmMicrosoft);
        this.mdmControlsShowMicrosoft=this.sureSimCompany.mdmMicrosoft;
      
      } else if (formGroup==this.portalDetailsForm && this.sureSimCompany != undefined) {
        this.portalDetailsForm.controls["portalDetails_Branding"].setValue(this.sureSimCompany.branding);
        this.portalDetailsForm.controls["portalDetails_CreateSubCompanies"].setValue(this.sureSimCompany.createSubCompanies);
        this.portalDetailsForm.controls["portalDetails_PortalAccess"].setValue(this.sureSimCompany.portalAccess);
        // this.setOrClearLogoFileValidators(this.sureSimCompany.branding);
        
        if (this.sureSimCompany.branding)
          this.getCompanyLogo();
        
      } else if (formGroup==this.ssoForm && this.sureSimCompany != undefined) {
        this.ssoForm.controls["ssoForm_ssoMicrosoft"].setValue(this.sureSimCompany.ssoMicrosoft);
        this.ssoForm.controls["ssoForm_ssoMicrosoftTenantId"].setValue(this.sureSimCompany.ssoMicrosoftTenantID);
        this.setOrClearSsoMicrosoftTenantIdValidators(this.sureSimCompany.ssoMicrosoft);
        this.ssoControlsShowMicrosoft=this.sureSimCompany.ssoMicrosoft;
        
      } else if (formGroup==this.usageLimitsForm && this.sureSimCompany != undefined) {
        this.selectedLimitType=this.sureSimCompany.companyUsageLimit?.limitType ?? LimitType.Spend;
        this.usageLimitsForm.controls["usageLimits_currencyId"].setValue(this.sureSimCompany.companyUsageLimit?.currencyID);
        this.usageLimitsForm.controls["usageLimits_dataLimit"].setValue(this.sureSimCompany.companyUsageLimit?.dataLimit ?? null);
        this.usageLimitsForm.controls["usageLimits_dataLimitUnit"].setValue(this.sureSimCompany.companyUsageLimit?.dataLimitDataWeightCode ?? "MB");
        this.usageLimitsForm.controls["usageLimits_limit"].setValue(this.sureSimCompany.companyUsageLimit?.limit);
        this.usageLimitsForm.controls["usageLimits_selfAuth"].setValue(this.sureSimCompany.companyUsageLimit?.limitSelfAuth);
        this.updateLimitTypeValidators();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onCompanyLocationSettingsChanged(): void {
    try {
      this.companyForm.markAsDirty();
      this.enableDisableControls(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //RBW_20260925 - The location awareness widget cannot host this modal (it is embedded by this form, so referencing the
  //               forms-modal module from it would be circular).
  public onEditLocationConsentTemplate(): void {
    try {
      if (this.sureSimCompanyId == undefined || this.sureSimCompanyId <= 0)
        return;

      forkJoin({
        defaults    : this.commConfigService.getCompanyCommunicationTemplatesDefaults(this.sureSimCompanyId)
                          .pipe(catchError(() => of(<CommunicationTemplatesDefaultsDTO>{ companyId: this.sureSimCompanyId, enteredBy: this.curUser.userId }))),
        replacements: this.commConfigService.getCommunicationTemplateReplacements(this.curUser.userId, MessageType.LocationConsentRequest)
                          .pipe(catchError(() => of(<CommunicationTemplateReplacements[]>[]))),
        template    : this.commConfigService.getCommunicationTemplate(this.sureSimCompanyId, MessageType.LocationConsentRequest, DeliveryType.SMS)
      })
      .subscribe({
        next : data => {
          this.locationConsentTemplateForm.openForm("",
                                                    JSON.parse(JSON.stringify(data.template)),
                                                    <number>this.sureSimCompanyId,
                                                    data.replacements,
                                                    data.defaults,
                                                    true, false, true, true, true);
        },
        error: error => { this.exceptionsService.handleException(new Error(error)); }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enableDisableControls(enabled: boolean) {
    try {
      this.submitButtonEnabled=enabled;

      this.updateSubmitButtonAppearance();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyFormSubmit() {
    try {
      this.companyFormSubmitted=true;

      if (this.selectedLimitType===LimitType.Spend) {
        const limitValue=Number(this.usageLimitsForm.get("usageLimits_limit")?.value);
        if (!isNaN(limitValue)) {
          this.usageLimitsForm.get("usageLimits_selfAuth")?.setValue(limitValue + 1);
        }
      }

      if (!this.basicDetailsForm.valid ||
        (this.mandatoryAddress && (this.companyAddressId==null || this.companyAddressId==undefined || this.companyAddressId<=0)) ||
        (this.mandatoryAddress && !this.billingAddressAsCompany && (this.billingAddressId==null || this.billingAddressId==undefined || this.billingAddressId<=0))) {
        this.arrowNav.select(this.navItemBasicDetails);
        
      } else if (!this.invoiceDetailsForm.valid) {
        this.arrowNav.select(this.navItemInvoiceDetails);
      
      } else if (!this.licenceDetailsForm.valid) {
        this.arrowNav.select(this.navItemLicenceDetails);
        
      } else if (!this.mdmForm.valid) {
        this.arrowNav.select(this.navItemDeviceManagement);
      
      } else if (!this.portalDetailsForm.valid ||
                 (this.portalDetailsForm.controls["portalDetails_Branding"].value && !this.haveLogoToUpload && !this.haveLogoFromDatabase)) {
        this.arrowNav.select(this.navItemPortalDetails);
        
      } else if (!this.ssoForm.valid) {
        this.arrowNav.select(this.navItemSingleSignOn);
        
      } else if (!this.usageLimitsForm.valid) {
        this.arrowNav.select(this.navItemUsageLimits);
        
      } else if (this.selectedLimitType===LimitType.Spend && parseInt(this.usageLimitsForm.get("usageLimits_selfAuth")?.value) <= parseInt(this.usageLimitsForm.get("usageLimits_limit")?.value)) {
        this.arrowNav.select(this.navItemUsageLimits);
        this.warningModalForm.openForm("Invalid Limits", "The Self Authorisation Value must be greater than the Default Usage Limit");

      } else if (this.createNewCompanySelected && !this.inviewCompanyCreated) {
        this.createInviewCompany();

      } else {
        this.checkChildrenCreditLimitBreachesThenSave();
      }
    }
    catch(e) {
      this.submitButtonEnabled=true;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private checkChildrenCreditLimitBreachesThenSave(): void {
    try {
      const creditLimitEnabled : boolean=this.invoiceDetailsForm.get("invoiceDetails_creditLimitEnabled")?.value ?? false;
      const creditLimitValueRaw=this.invoiceDetailsForm.get("invoiceDetails_creditLimit")?.value;
      const creditLimitValue   : number=parseFloat(creditLimitValueRaw);
      const creditLimitIsSet   : boolean=!isNaN(creditLimitValue) && creditLimitValue > 0;

      if (this.newCompany
          || !creditLimitEnabled
          || !creditLimitIsSet
          || !this.sureSimCompanyId
          || this.sureSimCompanyId<=0) {
        this.prepareToSaveCompany();
        return;
      }

      const request: ChildrenCreditLimitBreachRequestDTO={
        companyID          : this.sureSimCompanyId,
        creditLimitEnabled : creditLimitEnabled,
        proposedCreditLimit: creditLimitValue
      };

      this.companiesService.getChildrenCreditLimitBreaches(request)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
        })
      )
      .subscribe({
        next: (breaches: ChildCreditLimitBreachDTO[]) => {
          if (!breaches || breaches.length===0) {
            this.prepareToSaveCompany();
            return;
          }

          this.arrowNav.select(this.navItemInvoiceDetails);
          this.submitButtonEnabled=true;
          this.warningModalForm.openForm("Credit Limit Conflict", this.formatChildrenCreditLimitBreachesMessage(creditLimitValue, breaches));
        },
        error: error => {
          this.submitButtonEnabled=true;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.submitButtonEnabled=true;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private formatChildrenCreditLimitBreachesMessage(proposedLimit: number, breaches: ChildCreditLimitBreachDTO[]): string {
    try {
      const proposedFormatted: string="£" + proposedLimit.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const highest          : number=breaches.reduce((acc, b) => (b.creditLimit ?? 0) > acc ? (b.creditLimit ?? 0) : acc, 0);
      const highestFormatted : string="£" + highest.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

      const lines: string[]=breaches
        .slice()
        .sort((a, b) => (b.creditLimit ?? 0) - (a.creditLimit ?? 0))
        .map(b => " - " + (b.companyName ?? "(unnamed)") + ": £" + (b.creditLimit ?? 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

      return "Cannot set the credit limit to " + proposedFormatted + ". The following child companies have higher limits:\n\n" +
             lines.join("\n") +
             "\n\nEither raise this limit above " + highestFormatted + ", or lower the children first.";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "Cannot set the credit limit. One or more child companies have a higher configured limit.";
    }
  }

  public companyFormCancel() {
    try {
      this.unlockEntity();
      this.companyFormCancelled.emit();
      this.companyModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setOrClearValidatorsForTestMode(setValidators: boolean, setFieldValues: boolean): void {
    try {
      if (setValidators) {

        if (setFieldValues) {
          this.basicDetailsForm.controls["domain"     ].setValue(undefined);
          this.basicDetailsForm.controls["testAccount"].setValue(false);
        }

        this.basicDetailsForm.get("domain")?.setValidators([Validators.required, Validators.maxLength(this.domainMaxLength)]);

        if (this.mandatoryCompanyRegNo)
          this.basicDetailsForm.get("regno")?.setValidators([Validators.required, Validators.maxLength(this.regnoMaxLength)]);

        if (this.mandatoryVATNumber)
          this.basicDetailsForm.get("vatno")?.setValidators([Validators.required, Validators.maxLength(this.vatnoMaxLength)]);
        
        if (this.mandatoryAccountRef)
          this.invoiceDetailsForm.get("invoiceDetails_AccountRef")?.setValidators([Validators.required, Validators.maxLength(this.accountRefMaxLength)]);
        
        this.invoiceDetailsForm.get("invoiceDetails_CurrencyId"     )?.setValidators([Validators.required]);
        this.invoiceDetailsForm.get("invoiceDetails_PaymentMethodId")?.setValidators([Validators.required]);
        this.invoiceDetailsForm.get("invoiceDetails_PaymentTermId"  )?.setValidators([Validators.required]);
      }
      else {
        this.testAccountChkBxKeepVisible=true;
        
        if (setFieldValues) {
          this.basicDetailsForm.controls["domain"     ].setValue("exampleDomain.com");
          this.basicDetailsForm.controls["testAccount"].setValue(true);
        }
        
        this.basicDetailsForm.get("domain")?.clearValidators();
        this.basicDetailsForm.get("regno" )?.clearValidators();
        this.basicDetailsForm.get("vatno" )?.clearValidators();
        
        this.invoiceDetailsForm.get("invoiceDetails_AccountRef"     )?.clearValidators();
        this.invoiceDetailsForm.get("invoiceDetails_CurrencyId"     )?.clearValidators();
        this.invoiceDetailsForm.get("invoiceDetails_PaymentMethodId")?.clearValidators();
        this.invoiceDetailsForm.get("invoiceDetails_PaymentTermId"  )?.clearValidators();
      }
    
      this.basicDetailsForm.get("domain")?.updateValueAndValidity();
      this.basicDetailsForm.get("regno" )?.updateValueAndValidity();
      this.basicDetailsForm.get("vatno" )?.updateValueAndValidity();
      
      this.invoiceDetailsForm.get("invoiceDetails_AccountRef"     )?.updateValueAndValidity();
      this.invoiceDetailsForm.get("invoiceDetails_CurrencyId"     )?.updateValueAndValidity();
      this.invoiceDetailsForm.get("invoiceDetails_PaymentMethodId")?.updateValueAndValidity();
      this.invoiceDetailsForm.get("invoiceDetails_PaymentTermId"  )?.updateValueAndValidity();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Dropdown Arrays

  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="accountManagerId") {
        return this.accountManagerIdData;

      } else if (fieldName=="alertDefaultTemplateId") {
        return this.alertDefaultTemplatesIdData;

      } else if (fieldName=="companyTypeId") {
        return this.companyTypeIdData;

      } else if (fieldName=="countryId") {
        return this.countryIdData;

      } else if (fieldName=="inviewParentCompanyId") {
        return this.inviewParentCompanyIdData;

      } else if (fieldName=="invoiceDetails_CurrencyId") {
        return this.invoiceDetails_CurrencyIdData;

      } else if (fieldName=="invoiceDetails_PaymentMethodId") {
        return this.invoiceDetails_PaymentMethodIdData;
         
      } else if (fieldName=="invoiceDetails_PaymentTermId") {
        return this.invoiceDetails_PaymentTermIdData;

      } else if (fieldName=="supportPlanId") {
        return this.supportPlanIdData;

      } else if (fieldName=="usageLimits_currencyId") {
        return this.usageLimits_currencyIdData;

      }

      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  public getDropdownDataObjectArrayForInviewCompany(fieldName: string) {
    try {
      if (fieldName=="inviewCompanyId") {
        return this.inviewCompanyIdData;
      }

      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="accountManagerId") {
              this.accountManagerIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="alertDefaultTemplateId") {
              this.alertDefaultTemplatesIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="companyTypeId") {
              this.companyTypeIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="countryId") {
              this.countryIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="inviewCompanyId") {
              this.inviewCompanyIdData=(data as InviewCompanyDTO[]);

              if (this.userCanCreateTestAccounts) {
                this.inviewCompanyIdData.unshift({ address            : "",
                                                   companyId          : modalFormValues.createTestCompanyId,
                                                   companyName        : modalFormValues.createTestCompany,
                                                   parentId           : 0,
                                                   registerationNumber: "",
                                                   vatNo              : ""
                });
              }

              this.inviewCompanyIdData.unshift({ address            : "",
                                                 companyId          : modalFormValues.createNewCompanyId,
                                                 companyName        : modalFormValues.createNewCompany,
                                                 parentId           : 0,
                                                 registerationNumber: "",
                                                 vatNo              : ""
                                               });
              
              let _inviewCompanyId=(this.inviewCompanyIdData.length==1 || this.forceCreateNewCompany) ? modalFormValues.createNewCompanyId : this.inputInviewCompanyId;

              if ((this.inviewCompanyIdData.length==1 || this.forceCreateNewCompany) ||
                  (this.inputInviewCompanyId != undefined && (<number>this.inputInviewCompanyId>0  ||
                                                             (<number>this.inputInviewCompanyId==modalFormValues.createNewCompanyId))
                  )
                 ) {
                this.basicDetailsForm.controls["inviewCompanyId"].setValue(_inviewCompanyId);
                this.basicDetailsForm.controls["inviewCompanyId"].disable();
                this.inviewCompanySelectDropDownChange(undefined);
              }

            } else if (fieldName=="inviewParentCompanyId") {
              this.inviewParentCompanyIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="invoiceDetails_CurrencyId") {
              this.invoiceDetails_CurrencyIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="invoiceDetails_PaymentMethodId") {
              this.invoiceDetails_PaymentMethodIdData=(data as IdAndDescriptionDTO[]);
              
            } else if (fieldName=="invoiceDetails_PaymentTermId") {
              this.invoiceDetails_PaymentTermIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="supportPlanId") {
              this.supportPlans     =(data as TypeSupportPlanDTO[]);
              this.supportPlanIdData=this.supportPlans.map(plan => (<IdAndDescriptionDTO>{ id: plan.id, description: plan.supportPlan }));
              this.applyAccountManagerVisibility();

            } else if (fieldName=="usageLimits_currencyId") {
              this.usageLimits_currencyIdData=(data as IdAndDescriptionDTO[]);

            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Refresh Dropdown Arrays Data
  
  public refreshAccountManagerData() {
    try {
      this.getDropdownData(this.accountManagersService.getIdAndDescription(), "accountManagerId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshAlertDefaultTemplateData() {
    try {
      this.alertDefaultTemplatesIdData=[]
      this.getDropdownData(this.alertService.getAlertDefaultTemplateIdAndDescription(this.alertGroupId), "alertDefaultTemplateId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshCompanyTypeData() {
    try {
      this.getDropdownData(this.typesCompanyService.getIdAndDescription(), "companyTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshCountryData() {
    try {
      this.getDropdownData(this.countriesService.getIdAndDescription(), "countryId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshSupportPlanData() {
    try {
      this.getDropdownData(this.typesSupportPlanService.getAll(), "supportPlanId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Support Plan & Account Manager

  get selectedAccountManagerIdForSave(): number | null {
    try {
      if (!this.showAccountManager)
        return null;

      const selectedId=this.basicDetailsForm?.controls["accountManagerId"]?.value;

      return (selectedId==undefined || selectedId==="") ? null : <number>selectedId;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }

  get selectedSupportPlanIdForSave(): number | null {
    try {
      if (!this.showSupportPlan)
        return null;

      const selectedId=this.basicDetailsForm?.controls["supportPlanId"]?.value;

      return (selectedId==undefined || selectedId==="") ? null : <number>selectedId;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }

  get selectedSupportPlanTier(): number {
    try {
      const selectedId=this.basicDetailsForm?.controls["supportPlanId"]?.value;

      if (selectedId==undefined || selectedId==="")
        return EspTypeSupportPlan.Unknown;

      const plan=this.supportPlans.find(p => p.id==selectedId);

      return plan?.tier ?? EspTypeSupportPlan.Unknown;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return EspTypeSupportPlan.Unknown;
    }
  }

  private applyAccountManagerVisibility() {
    try {
      if (!this.showAccountManager)
        this.basicDetailsForm?.controls["accountManagerId"]?.setValue("");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public supportPlanDropDownChange(event: Event | undefined) {
    try {
      this.applyAccountManagerVisibility();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public refreshInvoiceDetailsCurrencyData() {
    try {
      this.getDropdownData(this.typesCurrencyService.getIdAndDescription(), "invoiceDetails_CurrencyId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshPaymentMethodData() {
    try {
      this.getDropdownData(this.typesPaymentService.getIdAndDescription(), "invoiceDetails_PaymentMethodId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public refreshPaymentTermData() {
    try {
      this.getDropdownData(this.typesPaymentTermService.getIdAndDescription(), "invoiceDetails_PaymentTermId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public refreshUsageLimitsCurrencyData() {
    try {
      this.getDropdownData(this.typesCurrencyService.getIdAndDescription(), "usageLimits_currencyId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public selectLimitType(limitType: number): void {
    try {
      this.selectedLimitType=limitType;
      this.updateLimitTypeValidators();

      //RBW_20260731 - Mirror the valueChanges handler so Submit is enabled.
      if (!this.newCompany && this.submitEnableOnEdit) {
        this.companyForm.markAsDirty();
        this.enableDisableControls(true);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private updateLimitTypeValidators(): void {
    try {
      const currencyId=this.usageLimitsForm.get("usageLimits_currencyId");
      const dataLimit =this.usageLimitsForm.get("usageLimits_dataLimit");
      const limit     =this.usageLimitsForm.get("usageLimits_limit");
      const selfAuth  =this.usageLimitsForm.get("usageLimits_selfAuth");

      currencyId?.clearValidators();
      selfAuth?.clearValidators();

      if (this.selectedLimitType===LimitType.Spend) {
        dataLimit?.clearValidators();
        limit?.setValidators([Validators.required]);
      } else if (this.selectedLimitType===LimitType.Data) {
        dataLimit?.setValidators([Validators.required]);
        limit?.clearValidators();
      } else {
        dataLimit?.clearValidators();
        limit?.clearValidators();
      }

      currencyId?.updateValueAndValidity();
      dataLimit?.updateValueAndValidity();
      limit?.updateValueAndValidity();
      selfAuth?.updateValueAndValidity();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Inview Company

  public refreshInviewCompanyData() {
    try {
      if (this.configSystemService.getValueAsBoolean(ConfigSystemParams.AddCompanyExcludeSureSimCompanies)) {
        this.getDropdownData(this.inviewCompaniesService.getByUserId_ExcludeSureSimCompanies(this.curUser.inviewUserId), "inviewCompanyId");

      } else {
        this.getDropdownData(this.inviewCompaniesService.getByUserId(this.curUser.inviewUserId), "inviewCompanyId");
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public inviewCompanySelectDropDownChange(ev: any) {
    try {
      this.resetMainVariables();
      this.basicDetailsForm.controls["inviewParentCompanyId"].setValue("");

      if (this.inviewCompanyIdData==undefined)
        return;

      this.enableDisableControls(false);
      this.setOrClearValidatorsForTestMode(this.basicDetailsForm.get('inviewCompanyId')?.value != modalFormValues.createTestCompanyId, true);

      if (this.basicDetailsForm.get('inviewCompanyId')?.value==modalFormValues.createNewCompanyId ||
          this.basicDetailsForm.get('inviewCompanyId')?.value==modalFormValues.createTestCompanyId) {
        this.alertColourProgress     =AlertClassColour.Green;
        this.createNewCompanySelected=true;
        this.progressInformation     =`New Company to be created`;

        this.basicDetailsForm.controls["inviewParentCompanyId"].enable();

      } else {
        this.selectedInviewCompany=this.inviewCompanyIdData.find(x => x.companyId==this.basicDetailsForm.get('inviewCompanyId')?.value);
        let gotCompany            =this.selectedInviewCompany?.companyId != undefined && <number>this.selectedInviewCompany?.companyId>0;      
  
        if (gotCompany) {
          this.companiesService.getIdByCompanyName(this.selectedInviewCompany?.companyName ?? "")
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              this.sureSimCompanyId=data.result;
  
              if (this.sureSimCompanyId<=0) {
                this.inviewCompanySelected=true;
                this.basicDetailsForm.controls["inviewParentCompanyId"].setValue(this.selectedInviewCompany?.parentId);
                this.basicDetailsForm.controls["inviewParentCompanyId"].disable();
                this.inviewParentCompanySelectDropDownChange(undefined);

              } else {
                this.alertColourProgress=AlertClassColour.Green;
                this.progressInformation=`"${this.selectedInviewCompany?.companyName}" is already ${ApplicationNames.eSimPlatform} registered`;
              }
            },
            error: error => {
              this.exceptionsService.handleException(new Error(error));
            }
          });
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private createInviewCompany() {
    try {
      this.submitButtonEnabled=false;
      let address             =this.addressAsString();

      var inviewCompany: InviewCompanyDTO={
        address            : address==undefined ? "UNKNOWN" : address,
        companyId          : 0,
        companyName        : this.basicDetailsForm.get("companyname")?.value,
        createdById        : this.curUser.inviewUserId,
        parentId           : this.basicDetailsForm.get("inviewParentCompanyId")?.value,
        registerationNumber: this.basicDetailsForm.get('regno')?.value,
        vatNo              : this.basicDetailsForm.get('vatno')?.value,
      };

      this.companiesService.canCreateCompanyUnder(<number>inviewCompany.parentId)
      .pipe(
        switchMap(canCreate => {
          if (canCreate?.result !== true)
            return throwError(() => "CompanyModalFormComponent.createInviewCompany() - You do not have permission to create a company under the selected parent company.");

          return this.postNewInviewCompany(inviewCompany);
        }),
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          //CRN_20260317 - Inview company created, so no duplicate Inview create attempt
          this.inviewCompanyCreated=true;

          this.selectedInviewCompany={
            address            : data.address,
            companyId          : data.companyId,
            companyName        : data.companyName,
            parentId           : data.parentId,
            registerationNumber: data.registerationNumber,
            vatNo              : data.vatNo,
          }

          this.prepareToSaveCompany();
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
          this.submitButtonEnabled=true;
          this.alertColourProgress=AlertClassColour.Red;
          this.progressInformation=`Process cannot continue - ${error.message}`;
        }
      });
    }
    catch(e) {
      this.submitButtonEnabled=true;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  postNewInviewCompany(inviewCompany: InviewCompanyDTO): Observable<InviewCompanyDTO> {
    return this.inviewCompaniesService.post(inviewCompany);
  }

  //#endregion

  //#region Inview Parent Company

  public refreshInviewParentCompanyData() {
    try {
      this.getDropdownData(this.inviewCompaniesService.getIdAndDescription(this.curUser.inviewUserId, this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyResellerOnlyParents)), "inviewParentCompanyId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public inviewParentCompanySelectDropDownChange(ev: any) {
    try {
      this.inviewParentCompanySelected=false;

      if (this.inviewParentCompanyIdData==undefined)
        return;

      this.enableDisableControls(false);

      this.selectedInviewParentCompany=this.inviewParentCompanyIdData.find(x => x.id==this.basicDetailsForm.get('inviewParentCompanyId')?.value);
      let gotCompany                  =this.selectedInviewParentCompany?.id != undefined && <number>this.selectedInviewParentCompany?.id>0;      

      if (!gotCompany) {
        this.alertColourProgress=AlertClassColour.Red;
        this.progressInformation="The Inview Parent Company cannot be determined";
      } else {
        this.companiesService.getIdByCompanyName(this.selectedInviewParentCompany?.description ?? "")
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.sureSimParentCompanyId=data.result;

            if (this.sureSimParentCompanyId<=0) {
              this.alertColourProgress=AlertClassColour.Red;
              this.progressInformation=`The parent company does not exist on the ${ApplicationNames.eSimPlatform} so must be created first`;

              if (this.inputInviewCompanyId != undefined && (<number>this.inputInviewCompanyId>0) ||
                                                            (<number>this.inputInviewCompanyId==modalFormValues.createNewCompanyId)) {
                this.basicDetailsForm.controls["inviewCompanyId"].enable();
              }
            } else {
              this.alertColourProgress        =AlertClassColour.Grey;
              this.inviewParentCompanySelected=true;
              this.progressInformation        =this.initialStatus;
              this.submitButtonEnabled        =true;

              this.basicDetailsForm.controls["companyname"].enable();
              this.basicDetailsForm.controls["regno"].enable();
              this.basicDetailsForm.controls["vatno"].enable();

              if (this.newCompany) {
                if (this.createNewCompanySelected) {
                  this.basicDetailsForm.controls["companyname"].setValue("");
                  this.basicDetailsForm.controls["regno"].setValue("");
                  this.basicDetailsForm.controls["vatno"].setValue("");

                } else {
                  this.basicDetailsForm.controls["companyname"].disable();
                  this.basicDetailsForm.controls["companyname"].setValue(this.selectedInviewCompany?.companyName);

                  if (this.selectedInviewCompany?.registerationNumber != undefined && this.selectedInviewCompany?.registerationNumber.trim() != "")
                    this.basicDetailsForm.controls["regno"].disable();

                  this.basicDetailsForm.controls["regno"].setValue(this.selectedInviewCompany?.registerationNumber);

                  if (this.selectedInviewCompany?.vatNo != undefined && this.selectedInviewCompany?.vatNo.trim() != "")
                    this.basicDetailsForm.controls["vatno"].disable();

                  this.basicDetailsForm.controls["vatno"].setValue(this.selectedInviewCompany?.vatNo);
                }
                
                this.selectCountryId=this.countriesService.getIdFromCountry(this.configSystemService.getValue(ConfigSystemParams.CountriesDefault));
                this.basicDetailsForm.controls["countryId"].setValue(this.selectCountryId);
                // this.basicDetailsForm.controls["postcodeLookupCompany"].setValue("");
                // this.basicDetailsForm.controls["postcodeLookupBilling"].setValue("");
                
                this.usageLimitsForm.controls["usageLimits_currencyId"].setValue(this.typesCurrencyService.getIdFromCurrencyCode(this.configSystemService.getValue(ConfigSystemParams.UsageLimitCompanyCurrencyCode)));
                this.usageLimitsForm.controls["usageLimits_limit"].setValue(this.configSystemService.getValue(ConfigSystemParams.UsageLimitCompany));
                this.usageLimitsForm.controls["usageLimits_selfAuth"].setValue(this.configSystemService.getValue(ConfigSystemParams.UsageLimitCompanySelfAuth));
              }
            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region SureSIM Company
    
  public getSureSimCompanyAndOpenModal() {
    try {
      this.companiesService.getById(<number>this.sureSimCompanyId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimCompany=data;
          this.enableFeatures();
          
          this.companyAddressId       =this.sureSimCompany.addressID;
          this.billingAddressId       =this.sureSimCompany.billingAddressID;
          this.billingAddressAsCompany=this.companyAddressId != null &&
                                       this.companyAddressId != undefined &&
                                       this.companyAddressId==this.billingAddressId;
          this.selectCountryId        =this.sureSimCompany.countryID;
          this.getAddress(this.companyAddressId, true);

          if (!this.billingAddressAsCompany) {
            this.getAddress(this.billingAddressId, false);
          }

          this.populateFormFields(this.basicDetailsForm);
          this.populateFormFields(this.invoiceDetailsForm);
          this.populateFormFields(this.licenceDetailsForm);
          this.populateFormFields(this.mdmForm);
          this.populateFormFields(this.portalDetailsForm);
          this.populateFormFields(this.ssoForm);
          this.populateFormFields(this.usageLimitsForm);
          this.applyCeasedState();
          this.openModal();

          if (this.openAtNavItem != undefined) {
            const navItem    =this.openAtNavItem;
            this.openAtNavItem=undefined;

            setTimeout(() => {
              this.arrowNav.select(navItem);
              if (navItem == this.navItemLocationServices || navItem == this.navItemSupport)
                this.companyModalFormRef?.update({ size: msSize.ExtraLarge });
            });
          }
          this.startWatchingForEdits();
         },
        error: error => {
          this.companyFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private startWatchingForEdits(): void {
    try {
      if (!this.companyForm)
        return;
  
      if (this.formChangesSubscription) {
        this.formChangesSubscription.unsubscribe();
        this.formChangesSubscription=undefined;
      }
  
      setTimeout(() => {
        this.formChangesSubscription=this.companyForm.valueChanges
          .pipe(debounceTime(50))
          .subscribe(_ => {
            if (!this.newCompany && this.submitEnableOnEdit) {
              this.enableDisableControls(this.companyForm.dirty);
            }
          });
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }


  private inventoryOrgIdForSave(): number | null {
    try {
      if (!this.showInventoryOrgId)
        return this.sureSimCompany?.inventoryOrgId ?? null;

      const value=this.basicDetailsForm.get("inventoryOrgId")?.value;

      return value==null || String(value).trim()==="" ? null : Number(value);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return this.sureSimCompany?.inventoryOrgId ?? null;
    }
  }

  private prepareToSaveCompany() {
    try
    {
      const newAccuracy=this.mapSimLocations?.locationSettingsLoaded ? this.mapSimLocations.locationAccuracyLevel : undefined;
      const oldAccuracy=this.sureSimCompany?.locationAccuracyLevelDefault;

      if (this.newCompany || newAccuracy==undefined || oldAccuracy==undefined || newAccuracy==oldAccuracy) {
        this.saveCompanyAfterAccuracyWarning();
        return;
      }

      this.submitButtonEnabled=false;

      this.locationAwarenessService.getCompanyAccuracyChangeImpact(this.sureSimCompanyId ?? -1, newAccuracy)
      .pipe(take(1))
      .subscribe({
        next : result => { this.warnAboutAccuracyChange(result?.consentCount ?? 0, result?.noticeCount ?? 0, oldAccuracy, newAccuracy); },
        //RBW_20261019 - The counts are only there to make the warning specific. Losing them must not stop the
        //               administrator saving, so the warning is still shown - just without numbers.
        error: ()     => { this.warnAboutAccuracyChange(undefined, undefined, oldAccuracy, newAccuracy); }
      });
    }
    catch(e) {
      this.submitButtonEnabled=true;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private warnAboutAccuracyChange(consentUsers: number | undefined,
                                  noticeUsers : number | undefined,
                                  oldAccuracy : number,
                                  newAccuracy : number): void {
    try {
      const oldLabel=this.mapSimLocations?.accuracyLabel(oldAccuracy) ?? "";
      const newLabel=this.mapSimLocations?.accuracyLabel(newAccuracy) ?? "";

      let consequence="";

      if (consentUsers==undefined) {
        consequence="Users whose consent no longer covers this accuracy will have location tracking switched off "
                    + "and will be sent a new consent request.";
      } else {
        if (consentUsers==0) {
          consequence="No users need to give their consent again.";
        } else {
          consequence=`<strong>${consentUsers}</strong> user${consentUsers==1 ? "" : "s"} will have location tracking `
                      + `switched off and will be sent a new consent request. `
                      + `Tracking stays off for them until they accept.`;
        }

        if ((noticeUsers ?? 0)>0) {
          consequence+=`<br><br><strong>${noticeUsers}</strong> user${noticeUsers==1 ? "" : "s"} already covered by what `
                       + `they agreed to will only be told the accuracy has changed, and will carry on being tracked.`;
        }
      }

      Swal.fire({
        title             : "Change the default location accuracy?",
        html              : `The company default is changing from <strong>${oldLabel}</strong> to <strong>${newLabel}</strong>.`
                            + `<br><br>${consequence}`
                            + `<br><br>This only affects users who do not set their own accuracy, and messages cannot be unsent.`,
        icon              : "question",
        showCancelButton  : true,
        confirmButtonText : "Save changes",
        cancelButtonText  : "Cancel",
        confirmButtonColor: "#299cdb"
      }).then((result) => {
        if (!result.isConfirmed) {
          this.submitButtonEnabled=true;
          return;
        }

        this.saveCompanyAfterAccuracyWarning();
      });
    }
    catch(e) {
      this.submitButtonEnabled=true;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private saveCompanyAfterAccuracyWarning() {
    try
    {
      this.submitButtonEnabled=false;
      let sureSimCompanyName  =this.basicDetailsForm.get("companyname")?.value;
      
      let companyUsageLimits: CompanyUsageLimitDTO={
        active                 : true,
        companyID              : 0,
        currencyID             : this.selectedLimitType===LimitType.Spend ? ((this.invoiceDetailsForm.get("invoiceDetails_CurrencyId")?.value || this.usageLimitsForm.get("usageLimits_currencyId")?.value) ?? -1) : null,
        dataLimit              : this.selectedLimitType===LimitType.Data  ? (this.usageLimitsForm.get("usageLimits_dataLimit")?.value  ?? null) : null,
        dataLimitDataWeightCode: this.selectedLimitType===LimitType.Data  ? (this.usageLimitsForm.get("usageLimits_dataLimitUnit")?.value ?? "MB") : null,
        enteredBy              : this.curUser.userId,
        id                     : 0,
        limit                  : this.selectedLimitType===LimitType.Spend ? (this.usageLimitsForm.get("usageLimits_limit")?.value      ?? null) : null,
        limitSelfAuth          : this.selectedLimitType===LimitType.Spend ? (this.usageLimitsForm.get("usageLimits_selfAuth")?.value   ?? null) : null,
        limitType              : this.selectedLimitType,
        startDate              : null
      };
      
      let company: CompanyDTO={
        accountManagerID              : this.selectedAccountManagerIdForSave,
        accountRef                    : this.invoiceDetailsForm.get("invoiceDetails_AccountRef")?.value,
        active                        : this.basicDetailsForm.controls["active"].value,
        addressID                     : this.companyAddressId,
        billingAddressID              : this.billingAddressAsCompany ? this.companyAddressId : this.billingAddressId,
        branding                      : this.portalDetailsForm.controls["portalDetails_Branding"].value,
        companyName                   : sureSimCompanyName,
        companyTypeID                 : this.basicDetailsForm.get("companyTypeId")?.value,
        companyUsageLimit             : companyUsageLimits,
        createSubCompanies            : this.portalDetailsForm.controls["portalDetails_CreateSubCompanies"].value,
        countryID                     : this.basicDetailsForm.get("countryId")?.value,
        creditLimit                   : this.creditLimitEnabled ? (this.invoiceDetailsForm.get("invoiceDetails_creditLimit")?.value ?? null) : null,
        creditLimitEnabled            : this.invoiceDetailsForm.get("invoiceDetails_creditLimitEnabled")?.value ?? false,
        creditLimitExceedAction       : this.invoiceDetailsForm.get("invoiceDetails_creditLimitExceedAction")?.value ?? 0,
        currentCreditLimit            : this.creditLimitEnabled ? (this.invoiceDetailsForm.get("invoiceDetails_currentCreditLimit")?.value ?? null) : null,
        domain                        : this.basicDetailsForm.get("domain")?.value,
        dropdownShowAtTop             : this.basicDetailsForm.controls["dropdownShowAtTop"].value,
        enteredBy                     : this.curUser.userId,
        guid                          : this.sureSimCompany?.guid==undefined ? Guid.create() : this.sureSimCompany?.guid,
        id                            : this.sureSimCompanyId ?? -1,
        inventoryOrgId                : this.inventoryOrgIdForSave(),
        inviewCompanyID               : (this.newCompany ? <number>this.selectedInviewCompany?.companyId : this.sureSimCompany?.inviewCompanyID) ?? -1,
        inviewParentCompanyID         : (this.newCompany ? <number>this.selectedInviewParentCompany?.id : this.sureSimCompany?.inviewParentCompanyID) ?? -1,
        invoice                       : this.invoiceDetailsForm.get("invoiceDetails_billFormat")?.value=="invoice" ? true : false,
        invoiceCurrencyID             : this.invoiceDetailsForm.get("invoiceDetails_CurrencyId")?.value,
        invoiceCurrencySymbol         : "", //RBW_20260519 - Not needed in the backend
        locationAccuracyLevelDefault  : this.mapSimLocations?.locationSettingsLoaded ? this.mapSimLocations.locationAccuracyLevel : (this.sureSimCompany?.locationAccuracyLevelDefault ?? 3),
        locationCountryAlwaysVisible  : this.mapSimLocations?.locationSettingsLoaded ? this.mapSimLocations.locationCountryAlwaysVisible : (this.sureSimCompany?.locationCountryAlwaysVisible ?? false),
        locationEnableForNewByDefault : this.mapSimLocations?.locationSettingsLoaded ? this.mapSimLocations.locationEnableForNewByDefault : (this.sureSimCompany?.locationEnableForNewByDefault ?? false),
        locationLastLocationOnly      : this.mapSimLocations?.locationSettingsLoaded ? this.mapSimLocations.locationLastLocationOnly : (this.sureSimCompany?.locationLastLocationOnly ?? false),
        //RBW_20260922 - System default is that user opt in IS required, so an unloaded/absent value falls back to true, never false.
        locationRequireUserOptIn      : this.mapSimLocations?.locationSettingsLoaded ? this.mapSimLocations.locationRequireUserOptIn : (this.sureSimCompany?.locationRequireUserOptIn ?? true),
        mdmDesensitise                : this.mdmForm.controls["mdmForm_mdmDesensitise"].value,
        mdmMicrosoft                  : this.mdmForm.controls["mdmForm_mdmMicrosoft"].value,
        mdmMicrosoftClientID          : this.mdmForm.controls["mdmForm_mdmMicrosoftClientId"].value,
        mdmMicrosoftClientSecretEnc   : this.mdmForm.controls["mdmForm_mdmMicrosoftClientSecret"].value,
        mdmMicrosoftTenantID          : this.mdmForm.controls["mdmForm_mdmMicrosoftTenantId"].value,
        paymentMethodID               : this.invoiceDetailsForm.get("invoiceDetails_PaymentMethodId")?.value,
        paymentTermID                 : this.invoiceDetailsForm.get("invoiceDetails_PaymentTermId")?.value,
        portalAccess                  : this.portalDetailsForm.controls["portalDetails_PortalAccess"].value,
        pureSSCompany                 : (this.newCompany ? this.createNewCompanySelected : this.sureSimCompany?.pureSSCompany) ?? false,
        regNo                         : this.basicDetailsForm.get("regno")?.value,
        ssoMicrosoft                  : this.ssoForm.controls["ssoForm_ssoMicrosoft"].value,
        ssoMicrosoftTenantID          : this.ssoForm.controls["ssoForm_ssoMicrosoftTenantId"].value,
        statement                     : this.invoiceDetailsForm.get("invoiceDetails_billFormat")?.value=="statement" ? true : false,
        supportPlanID                 : this.selectedSupportPlanIdForSave,
        testAccount                   : this.basicDetailsForm.controls["testAccount"].value,
        topLevelCompany               : false,
        travelRiskExtendedOfflineHours: this.mapSimLocations?.locationSettingsLoaded ? this.mapSimLocations.travelRiskExtendedOfflineHours : (this.sureSimCompany?.travelRiskExtendedOfflineHours ?? null),
        vatNo                         : this.basicDetailsForm.get("vatno")?.value,
        visibilityChangeReason        : (this.mapSimLocations?.locationChangeReason ?? '').trim()!='' ? this.mapSimLocations.locationChangeReason.trim() : null,
      };
      
      this.saveCompany(company)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.alertColourProgress=AlertClassColour.Green;

          this.mapSimLocations?.commitCompanyLocationSettings();
          this.mapSimLocations?.afterVisibilitySave();

          if (this.newCompany) {
            this.progressInformation=`${sureSimCompanyName} has been registered on the ${ApplicationNames.eSimPlatform}`;
          } else {
            this.progressInformation=`${sureSimCompanyName} details have been updated on the ${ApplicationNames.eSimPlatform}`;
          }

          this.processComplete();

          if (this.newCompany) {
            this.sureSimCompanyId=data["id"];
          }

          this.uploadLogoFile();
          this.uploadStatementLogoFile();

          let inviewCompanyId=<number>this.selectedInviewCompany?.companyId;

          this.inviewCompanyDataHasBeenSaved.emit(inviewCompanyId);
          this.sureSimCompanyDataHasBeenSaved.emit(this.sureSimCompanyId);
        },
        error: error => {
          this.submitButtonEnabled=true;
          this.alertColourProgress=AlertClassColour.Red;
          this.progressInformation=`Process cannot continue - ${error.message}`;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.submitButtonEnabled=true;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private saveCompany(company: CompanyDTO): Observable<CompanyDTO> {
    return this.companiesService.save(company);
  }

  //#endregion

  //#region Cease Company

  private applyCeasedState(): void {
    try {
      if (this.sureSimCompany?.ceased!==true)
        return;

      this.fileLockHoverText="Company ceased" +
                             (this.sureSimCompany?.ceasedDate ? " on " + this.datePipe.transform(this.sureSimCompany.ceasedDate, 'dd/MM/yyyy HH:mm', 'UTC') : "");
      this.formIsLocked     =true;
      this.formTitle        ="Manage Company (Ceased)";

      this.lockDownForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private ceasedStateChanged(title        : string,
                             message      : string,
                             animationLink: string,
                             colour       : string): void {
    try {
      this.ceaseInProgress=false;

      this.unlockEntity();
      this.ceaseCompletedModalForm.openForm(title, message, animationLink, colour, OurColors.DarkBlue);
      this.sureSimCompanyDataHasBeenSaved.emit(this.sureSimCompanyId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private ceasedStateFailed(): void {
    try {
      this.ceaseInProgress=false;

      this.unlockEntity();
      this.sureSimCompanyDataHasBeenSaved.emit(this.sureSimCompanyId);
      this.companyModalFormRef?.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ceaseCompanyClick(): void {
    try {
      if ((!this.canCeaseCompany && !this.canRepeatCease) || this.ceaseBlockedBySims)
        return;

      const companyName: string=this.sureSimCompany?.companyName ?? "";

      //CRN_20261021 - Cease is permanent, personal data removed
      // this.ceaseCompanyConfirmModal.openForm("Cease " + (this.sureSimCompany?.companyName ?? "Company") + "?",
      //                                        "This company & all of its sub-companies will be ceased. "
      //                                        + "<br>"
      //                                        + "Their users will no longer be able to log in & location awareness will be switched off. "
      //                                        + "<br>"
      //                                        + "Personal data such as names, telephone numbers & email addresses will be anonymised. "
      //                                        + "<br>"
      //                                        + "Usage & billing data are kept. An administrator can reinstate the company if required.",
      //                                        "https://cdn.lordicon.com/ypnsnhgh.json",
      //                                        OurColors.Red,
      //                                        OurColors.DarkBlue,
      //                                        "Cease Company",
      //                                        "Cancel");
      if (this.canRepeatCease) {
        this.ceaseCompanyConfirmModal.openForm("Repeat cease of " + companyName + "?",
                                               "This removes any personal data that the original cease could not remove, "
                                               + "for example if an external update failed. "
                                               + "<br>"
                                               + "It cannot be undone.",
                                               "https://cdn.lordicon.com/ypnsnhgh.json",
                                               OurColors.Red,
                                               OurColors.DarkBlue,
                                               "Repeat Cease",
                                               "Cancel",
                                               companyName);
        return;
      }

      this.ceaseCompanyConfirmModal.openForm("Permanently cease " + companyName + "?",
                                             "This company & all of its sub-companies will be ceased. "
                                             + "<br>"
                                             + "Their users will no longer be able to log in. "
                                             + "<br>"
                                             + "Personal data such as names, telephone numbers, email addresses, messages & location history will be permanently removed. "
                                             + "<br>"
                                             + "Usage & billing data are kept. "
                                             + "<br>"
                                             + "<strong>This cannot be undone & the company cannot be reinstated.</strong>",
                                             "https://cdn.lordicon.com/ypnsnhgh.json",
                                             OurColors.Red,
                                             OurColors.DarkBlue,
                                             "Cease Company",
                                             "Cancel",
                                             companyName);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //CRN_20261021 - Retired
  // public unceaseCompanyClick(): void {
  //   try {
  //     if (!this.canUnceaseCompany)
  //       return;
  //
  //     this.unceaseCompanyConfirmModal.openForm("Reinstate " + (this.sureSimCompany?.companyName ?? "Company") + "?",
  //                                              "This company and its sub-companies will be made live again. "
  //                                              + "<br>"
  //                                              + "Users' personal data, login access & location awareness will be restored to how they were before the company was ceased.",
  //                                              "https://cdn.lordicon.com/lupuorrc.json",
  //                                              OurColors.Green,
  //                                              OurColors.DarkBlue,
  //                                              "Reinstate Company",
  //                                              "Cancel");
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //   }
  // }

  public yesCeaseCompany(confirmCompanyName: string): void {
    try {
      if (!this.canCeaseCompany && !this.canRepeatCease)
        return;

      this.ceaseInProgress=true;

      this.companiesService.cease(<number>this.sureSimCompanyId, confirmCompanyName ?? "")
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next : () => {
          this.ceasedStateChanged("Company Ceased",
                                  "The company has been ceased",
                                  "https://cdn.lordicon.com/ypnsnhgh.json",
                                  OurColors.Red);
        },
        error: error => {
          this.ceasedStateFailed();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.ceaseInProgress=false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //CRN_20261021 - Retired
  // public yesUnceaseCompany(): void {
  //   try {
  //     if (!this.canUnceaseCompany)
  //       return;
  //
  //     this.ceaseInProgress=true;
  //
  //     this.companiesService.uncease(<number>this.sureSimCompanyId)
  //     .pipe(
  //       catchError((error) => {
  //         return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
  //       })
  //     )
  //     .subscribe({
  //       next : () => {
  //         this.ceasedStateChanged("Company Reinstated",
  //                                 "The company has been reinstated",
  //                                 "https://cdn.lordicon.com/lupuorrc.json",
  //                                 OurColors.Green);
  //       },
  //       error: error => {
  //         this.ceasedStateFailed();
  //         this.exceptionsService.handleException(new Error(error));
  //       }
  //     });
  //   }
  //   catch(e) {
  //     this.ceaseInProgress=false;
  //     this.exceptionsService.handleException(<Error>e);
  //   }
  // }

  //#endregion

  //#region Process Complete

  private processComplete() {
    try {
      this.completedModalForm.openForm(this.newCompany ? "Company Created" : "Company Details Updated", "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalHasBeenClosed() {
    try {
      this.companyModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Address

  public asCompanyAddressClick() {
    try {
      this.billingAddressAsCompany=!this.basicDetailsForm.get("asCompanyAddress")?.value;
      
      if (this.billingAddressAsCompany) {
        this.billingAddressId=this.companyAddressId;

        this.setAddressControlValues(this.companyAddress, false);

      } else {
        this.billingAddressId=null;

        this.setAddressControlValues(undefined, false);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public getAddress(addressId: null | number | undefined, isCompanyAddress: boolean) {
    try {
      if (addressId != null && addressId != undefined && addressId>0) {
        this.addressesService.getById(addressId)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.setAddressControlValues(data, isCompanyAddress);

            if (isCompanyAddress) {
              this.companyAddress=data;
              
              if (this.billingAddressAsCompany) {
                this.setAddressControlValues(this.companyAddress, false);
              }
            }
           },
          error: error => {
            this.companyFormCancelled.emit();
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public setAddressControlValues(address: AddressDTO | undefined, isCompanyAddress: boolean) {
    try {
      let prefix: string=isCompanyAddress ? "company" : "billing";

      this.basicDetailsForm.controls[prefix + "AddrCountryId" ].setValue(address==undefined ? null : address.countryID );
      this.basicDetailsForm.controls[prefix + "AddrCounty"    ].setValue(address==undefined ? null : address.county    );
      this.basicDetailsForm.controls[prefix + "AddrLine1"     ].setValue(address==undefined ? null : address.line1     );
      this.basicDetailsForm.controls[prefix + "AddrLine2"     ].setValue(address==undefined ? null : address.line2     );
      this.basicDetailsForm.controls[prefix + "AddrLine3"     ].setValue(address==undefined ? null : address.line3     );
      this.basicDetailsForm.controls[prefix + "AddrPostCode"  ].setValue(address==undefined ? null : address.postCode  );
      this.basicDetailsForm.controls[prefix + "AddrTownOrCity"].setValue(address==undefined ? null : address.townOrCity);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public editAddress(isCompanyAddress: boolean) {
    try {
      this.editingCompanyAddress=isCompanyAddress;
      let haveAddress           =(isCompanyAddress  && this.companyAddressId != null && this.companyAddressId != undefined && this.companyAddressId>0) ||
                                 (!isCompanyAddress && this.billingAddressId != null && this.billingAddressId != undefined && this.billingAddressId>0);

      if (!this.addressModalFormIsOpen) {
        this.addressModalFormIsOpen=true;

        if (this.newCompany && !haveAddress)
          this.addressModalForm.openForm(0);
        else {
          if (isCompanyAddress) {
            this.addressModalForm.openForm(this.companyAddressId);

          } else {
            this.addressModalForm.openForm(this.billingAddressId);
          }
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public addressDataHasBeenSaved(address: AddressDTO | undefined) {
    try {
      this.addressModalFormIsOpen=false;

      if (address != undefined && address.id>0) {
        if (this.editingCompanyAddress) {
          this.companyAddress  =address;
          this.companyAddressId=address.id;
          this.setAddressControlValues(address, true);

          if (this.billingAddressAsCompany) {
            this.billingAddressId=address.id;
            this.setAddressControlValues(address, false);
          }

        } else {
          this.billingAddressId=address.id;
          this.setAddressControlValues(address, false);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public addressFormHasBeenCancelled() {
    try {
      this.addressModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public addressAsString(): string | undefined {
    try {
      let result: string="";

      if (this.basicDetailsForm.get("companyAddrLine1")?.value != undefined && this.basicDetailsForm.get("companyAddrLine1")?.value != null && this.basicDetailsForm.get("companyAddrLine1")?.value.trim() != "") {
        result += this.basicDetailsForm.get("companyAddrLine1")?.value;
      }

      if (this.basicDetailsForm.get("companyAddrLine2")?.value != undefined && this.basicDetailsForm.get("companyAddrLine2")?.value != null && this.basicDetailsForm.get("companyAddrLine2")?.value.trim() != "") {
        if (result != "")
          result += "\n";

        result += this.basicDetailsForm.get("companyAddrLine2")?.value;
      }

      if (this.basicDetailsForm.get("companyAddrLine3")?.value != undefined && this.basicDetailsForm.get("companyAddrLine3")?.value != null && this.basicDetailsForm.get("companyAddrLine3")?.value.trim() != "") {
        if (result != "")
          result += "\n";

        result += this.basicDetailsForm.get("companyAddrLine3")?.value;
      }

      if (this.basicDetailsForm.get("companyAddrTownOrCity")?.value != undefined && this.basicDetailsForm.get("companyAddrTownOrCity")?.value != null && this.basicDetailsForm.get("companyAddrTownOrCity")?.value.trim() != "") {
        if (result != "")
          result += "\n";

        result += this.basicDetailsForm.get("companyAddrTownOrCity")?.value;
      }

      if (this.basicDetailsForm.get("companyAddrCounty")?.value != undefined && this.basicDetailsForm.get("companyAddrCounty")?.value != null && this.basicDetailsForm.get("companyAddrCounty")?.value.trim() != "") {
        if (result != "")
          result += "\n";

        result += this.basicDetailsForm.get("companyAddrCounty")?.value;
      }

      if (this.basicDetailsForm.get("companyAddrPostCode")?.value != undefined && this.basicDetailsForm.get("companyAddrPostCode")?.value != null && this.basicDetailsForm.get("companyAddrPostCode")?.value.trim() != "") {
        if (result != "")
          result += "\n";

        result += this.basicDetailsForm.get("companyAddrPostCode")?.value;
      }

      return result.substring(1, this.inviewAddressMaxLength);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  //#endregion

  //#region Alerts

  public alertGroupChanged(alertGroupId : number) {
    try {
      this.alertGroupId                      = alertGroupId;
      this.alertdefaulttemplate.alertGroupId = alertGroupId;
      this.alertdefaulttemplate.refreshData();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyFormAlert() {
    try {
        if (this.newCompany && !this.enableAlertsOnNew) {
          this.informationModalForm.openForm("Information", "Please save the company details before adding alerts");
        } else {
          this.alertModalForm.openForm(-1, this.sureSimCompanyId ?? -1, this.selectedAlertTemplateId, this.alertGroupId);
        }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyFormAlertAdded() {
    try {
      this.alertsForm.refresh();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyAlertSaved() {
    try {       
      this.alertdefaulttemplate.refreshData();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    } 
  }

  public companyFormAlertTemplate(templateId : number) {
    try {
      this.selectedAlertTemplateId = templateId;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Active, PortAccess & TestAccount Checkboxes

  public activeClick() {
    try {
      this.ownCompanyCheck();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public portalAccessClick() {
    try {
      this.ownCompanyCheck();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ownCompanyCheck() {
    try {
      if (!this.newCompany && this.sureSimCompany!.id==this.curUser.companyId) {
        this.warningModalForm.openForm("Cannot Action", "You cannot change either the 'Active' or 'Portal Access' values of your own company. Please contact your parent company to action.");
        this.basicDetailsForm.controls["active"].setValue(true);
        this.portalDetailsForm.controls["portalDetails_PortalAccess"].setValue(true);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public testAccountClick() {
    try {
      let checked=!this.basicDetailsForm.get("testAccount")?.value;

      this.setOrClearValidatorsForTestMode(!checked, false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public countryIdDropDownChange(e: any) {
    try {
      this.selectCountryId=this.basicDetailsForm.get("countryId")?.value;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyTypeDropDownChange(event: Event) {
    try {
      if (this.newCompany) {
        const rawValue  =(event.target as HTMLSelectElement).value;
        const idPart    =rawValue.includes(':') ? rawValue.split(':')[0].trim() : rawValue;
        const selectedId=Number(idPart) || -1;
  
        this.portalDetailsForm.controls["portalDetails_CreateSubCompanies"].setValue(this.canCreateSubCompaniesCompanyTypeIds.includes(selectedId));
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#region Invoice Details
    
  public billRecipientsGridAddButtonClick() {
    try {
      if (!this.userModalFormIsOpen) {
        this.userModalFormIsOpen=true;
        this.userModalForm.openForm(0, eUser.associate);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public billRecipientsGridEditButtonClick(user: UserDTO) {
    try {
      if (!this.userModalFormIsOpen) {
        let userType: eUser=(user.portalUser ? eUser.portal : (user.eSimUser ? eUser.sim : eUser.associate));
        
        this.userModalFormIsOpen=true;
        this.userModalForm.openForm(user.id, userType);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public userModalFormDataHasBeenSaved(user: UserDTO) {
    try {
      this.userModalFormIsOpen=false;
      this.usersAllComponent?.gridView?.refreshData();
      this.usersPortalComponent?.gridView?.refreshData();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public userModalFormHasBeenCancelled() {
    try {
      this.userModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public showBillingOnlyClick() {
    try {
      let checked=this.invoiceDetailsForm.get("invoiceDetails_BillOnly")?.value;

      if (checked != undefined) {
        checked=!checked;

        this.billingRecipientsFilterExpr=checked ? ['sendBill', '=', true] : null;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Credit Limits

  public get creditLimitEditBlocked(): boolean {
    try {
      if (this.newCompany)
        return false;

      if (this.curUser.topLevelCompany)
        return false;

      return (this.sureSimCompany?.id ?? 0)===this.curUser.companyId;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return true;
    }
  }

  private applyCreditLimitEditGuard(): void {
    try {
      if (!this.creditLimitEditBlocked)
        return;

      this.invoiceDetailsForm.get("invoiceDetails_creditLimit")?.disable();
      this.invoiceDetailsForm.get("invoiceDetails_creditLimitEnabled")?.disable();
      this.invoiceDetailsForm.get("invoiceDetails_creditLimitExceedAction")?.disable();
      this.invoiceDetailsForm.get("invoiceDetails_currentCreditLimit")?.disable();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public creditLimitEnabledToggle(): void {
    try {
      this.creditLimitEnabled=this.invoiceDetailsForm.get("invoiceDetails_creditLimitEnabled")?.value ?? false;

      const creditLimit            =this.invoiceDetailsForm.get("invoiceDetails_creditLimit");
      const creditLimitExceedAction=this.invoiceDetailsForm.get("invoiceDetails_creditLimitExceedAction");
      const currentCreditLimit     =this.invoiceDetailsForm.get("invoiceDetails_currentCreditLimit");

      if (this.creditLimitEnabled) {
        creditLimit?.setValidators([Validators.required]);
        creditLimitExceedAction?.setValidators([Validators.required]);
        
      } else {
        creditLimit?.clearValidators();
        creditLimit?.setValue(null);
        creditLimitExceedAction?.clearValidators();
        creditLimitExceedAction?.setValue(null);
        currentCreditLimit?.setValue(null);
      }

      creditLimit?.updateValueAndValidity();
      creditLimitExceedAction?.updateValueAndValidity();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private loadParentCompanyCreditLimit(): void {
    try {
      const childId: number=this.sureSimCompany?.id ?? 0;

      if (childId<=0 || (this.sureSimCompany?.parentCompanyID_ExcludeRoot ?? 0)<=0) {
        this.parentCompanyCreditLimit=null;
        return;
      }

      this.companiesService.getParentCreditLimit(childId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
        })
      )
      .subscribe({
        next : data  => {
          this.parentCompanyCreditLimit=data?.result ?? null;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public get parentCreditLimitHint(): string {
    try {
      if (this.parentCompanyCreditLimit==null)
        return "";

      return "Parent limit: £" + this.parentCompanyCreditLimit.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public get creditLimitExceedsParent(): boolean {
    try {
      if (this.parentCompanyCreditLimit==null)
        return false;

      let val: number=parseFloat(this.invoiceDetailsForm.get("invoiceDetails_creditLimit")?.value);
      return !isNaN(val) && val > this.parentCompanyCreditLimit;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public get currentCreditLimitExceedsParent(): boolean {
    try {
      if (this.parentCompanyCreditLimit==null)
        return false;

      let val: number=parseFloat(this.invoiceDetailsForm.get("invoiceDetails_currentCreditLimit")?.value);
      return !isNaN(val) && val > this.parentCompanyCreditLimit;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  //#endregion

  //#region Portal Details
  
  public getIdForCompanyFileTypeLogo() {
    try {
      this.typesCompanyFileService.getIdAndDescription()
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          const typeCompanyFile: IdAndDescriptionDTO | undefined=data.find(x => x.description==TypeCompanyFile.Logo);

          if (!typeCompanyFile)
            this.exceptionsService.handleException(new Error(`CompanyModalFormComponent - CompanyFileType for ${TypeCompanyFile.Logo} cannot be determined`));

          this.companyFileTypeId=Number(typeCompanyFile?.id);

          const typeStatementLogo: IdAndDescriptionDTO | undefined=data.find(x => x.description==TypeCompanyFile.StatementLogo);

          this.statementLogoFileTypeId=typeStatementLogo ? Number(typeStatementLogo.id) : undefined;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  public getIdsForCompanyTypes() {
    try {
      this.typesCompanyService.getIdAndDescription()
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          let typeCompany: IdAndDescriptionDTO | undefined=data.find(x => x.description==TypeCompany.Distributor);
          
          if (!typeCompany || !typeCompany.id)
            this.exceptionsService.handleException(new Error(`CompanyModalFormComponent - CompanyType for ${TypeCompany.Distributor} cannot be determined`));
          
          this.canCreateSubCompaniesCompanyTypeIds.push(Number(typeCompany!.id));

          typeCompany=data.find(x => x.description==TypeCompany.ResellerCommissioned);
          
          if (!typeCompany || !typeCompany.id)
            this.exceptionsService.handleException(new Error(`CompanyModalFormComponent - CompanyType for ${TypeCompany.ResellerCommissioned} cannot be determined`));
          
          this.canCreateSubCompaniesCompanyTypeIds.push(Number(typeCompany!.id));

          typeCompany=data.find(x => x.description==TypeCompany.ResellerWholesale);
          
          if (!typeCompany || !typeCompany.id)
            this.exceptionsService.handleException(new Error(`CompanyModalFormComponent - CompanyType for ${TypeCompany.ResellerWholesale} cannot be determined`));
          
          this.canCreateSubCompaniesCompanyTypeIds.push(Number(typeCompany!.id));
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getCompanyLogo() {
    try {
      this.fileService.getFileByCompanyIdAndCompanyFileTypeId(this.sureSimCompany?.id, this.companyFileTypeId ?? -1)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          const base64Content =data!.fileDownload!.fileContents;
          const byteCharacters=atob(base64Content);
          const byteNumbers   =new Array(byteCharacters.length);
    
          for (let i=0; i<byteCharacters.length; i++) {
            byteNumbers[i]=byteCharacters.charCodeAt(i);
          }
          
          const byteArray          =new Uint8Array(byteNumbers);
          const blob               =new Blob([byteArray], { type: data!.contentType });
          const objectUrl          =URL.createObjectURL(blob);
          this.logoFileUrl         =objectUrl;
          this.haveLogoFromDatabase=true;
          
          // this.setOrClearLogoFileValidators(false);
        },
        error: error => {
          let raiseError: boolean=true;
                                        
          if (error.message.includes(ErrorStrings.CannotBeFound))
            raiseError=false;
          
          if (raiseError)
            this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public brandedPortalClick(): void {
    try {
      const checked: boolean=!this.portalDetailsForm.get("portalDetails_Branding")?.value;

      // this.setOrClearLogoFileValidators(checked);

      if (checked)
        this.logoFileUrl=null;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  // public setOrClearLogoFileValidators(set: boolean): void {
  //   try {
  //     if (!this.portalDetailsForm)
  //       return;

  //     if (set) {
  //       this.portalDetailsForm.get("portalDetails_logoFileData")?.setValidators(Validators.required);
  //       this.portalDetailsForm.get("portalDetails_logoFileData")?.updateValueAndValidity();
        
  //     } else {
  //       this.portalDetailsForm.get("portalDetails_logoFileData")?.clearValidators();
  //       this.portalDetailsForm.get("portalDetails_logoFileData")?.updateValueAndValidity();
  //     }
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //   }
  // }

  public triggerLogoFileInput(): void {
    try {
      document.getElementById("portalDetails_logoFileData-field")?.click();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public logoFileSelected(event: Event): void {
    try {
      const input=event.target as HTMLInputElement;

      if (input.files && input.files.length>0) {
        this.haveLogoFromDatabase=false;
        this.haveLogoToUpload    =true;
        this.logoFile            =input.files[0];
        this.logoFileUrl         =URL.createObjectURL(this.logoFile);

      } else {
        this.haveLogoToUpload=false;
        this.logoFile        =null;
        this.logoFileUrl     =null;
      }

      if (!this.newCompany && this.submitEnableOnEdit) {
        this.companyForm.markAsDirty();
        this.enableDisableControls(true);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Statement logo
  
  public getCompanyStatementLogo(): void {
    try {
      if (!this.showStatementLogo
          || this.statementLogoFileTypeId==undefined
          || Number(this.sureSimCompany?.id ?? 0)<=0)
        return;

      this.fileService.getFileByCompanyIdAndCompanyFileTypeId(this.sureSimCompany?.id, this.statementLogoFileTypeId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          const base64Content=data?.fileDownload?.fileContents;

          if (!base64Content) {
            this.haveStatementLogoFromDatabase=false;
            this.statementLogoFileUrl         =null;
            return;
          }

          const byteCharacters=atob(base64Content);
          const byteNumbers   =new Array(byteCharacters.length);

          for (let i=0; i<byteCharacters.length; i++) {
            byteNumbers[i]=byteCharacters.charCodeAt(i);
          }

          const byteArray=new Uint8Array(byteNumbers);
          const blob     =new Blob([byteArray], { type: data!.contentType });

          this.statementLogoFileUrl         =URL.createObjectURL(blob);
          this.haveStatementLogoFromDatabase=true;
        },
        error: error => {
          let raiseError: boolean=true;

          if (error.message.includes(ErrorStrings.CannotBeFound))
            raiseError=false;

          if (raiseError)
            this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public statementLogoFileSelected(event: Event): void {
    try {
      const input=<HTMLInputElement>event.target;

      if (input.files && input.files.length>0) {
        this.haveStatementLogoFromDatabase=false;
        this.haveStatementLogoToUpload    =true;
        this.statementLogoFile            =input.files[0];
        this.statementLogoFileUrl         =URL.createObjectURL(this.statementLogoFile);

      } else {
        this.haveStatementLogoToUpload=false;
        this.statementLogoFile        =null;
        this.statementLogoFileUrl     =null;
      }

      if (!this.newCompany && this.submitEnableOnEdit) {
        this.companyForm.markAsDirty();
        this.enableDisableControls(true);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public triggerStatementLogoFileInput(): void {
    try {
      document.getElementById('invoiceDetails_statementLogoFileData-field')?.click();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public uploadStatementLogoFile(): void {
    try {
      if (!this.haveStatementLogoToUpload || !this.showStatementLogo)
        return;

      const formData=new FormData();
      formData.append("active",            "true");
      formData.append("companyFileTypeID", this.statementLogoFileTypeId?.toString() ?? "");
      formData.append("companyID",         this.sureSimCompanyId?.toString() ?? "");
      formData.append("enteredBy",         this.curUser.userId.toString());
      formData.append("fileUpload",        <Blob>this.statementLogoFile);

      this.fileService.uploadCompanyFileData(formData)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {

        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public uploadLogoFile() {
    try {
      if (!this.haveLogoToUpload)
        return;

      const formData=new FormData();
      formData.append("active",            "true");
      formData.append("companyFileTypeID", this.companyFileTypeId?.toString() ?? "");
      formData.append("companyID",         this.sureSimCompanyId?.toString() ?? "");
      formData.append("enteredBy",         this.curUser.userId.toString());
      formData.append("fileUpload",        <Blob>this.logoFile);
      
      this.fileService.uploadCompanyFileData(formData)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public portalUsersGridAddButtonClick() {
    try {
      if (!this.userModalFormIsOpen) {
        this.userModalFormIsOpen=true;
        this.userModalForm.openForm(0, eUser.portal);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public portalUsersGridEditButtonClick(user: UserDTO) {
    try {
      if (!this.userModalFormIsOpen) {
        this.userModalFormIsOpen=true;
        this.userModalForm.openForm(user.id, eUser.portal);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Licence Details
  
  public showCompanyVisibleLicencesClick() {
    try {
      if (this.licenceDetailsForm.get("licenceDetailsForm_visible")?.value != undefined) {
        this.licencesAllowedShowing=!this.licenceDetailsForm.get("licenceDetailsForm_visible")?.value;
        this.licencesGridTitle     =this.licencesAllowedShowing ? this.licencesGridTitleVisible : this.licencesGridTitleAllocated;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Messaging
  
  public messageClick() {
    try {
      if (!this.communicationModalFormIsOpen) {
        this.communicationModalFormIsOpen=true;

        this.showComposeForm=true;
        this.changeDetectorRef.detectChanges();
        this.communicationComposeModalForm.openForm(this.sureSimCompanyId);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public communicationDataHasBeenSaved(communicationId: number | undefined) {
    try {
      this.communicationModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public communicationFormHasBeenCancelled() {
    try {
      this.communicationModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Single Sign-On

  //#region Microsoft SSO
  
  public ssoMicrosoftClick(): void {
    try {
      const ssoEnabled: boolean    =!this.ssoForm.get("ssoForm_ssoMicrosoft")?.value;
      this.ssoControlsShowMicrosoft=ssoEnabled;
      
      if (!ssoEnabled)
        this.ssoForm.controls["ssoForm_ssoMicrosoftTenantId"].setValue(undefined);

      this.setOrClearSsoMicrosoftTenantIdValidators(ssoEnabled);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public setOrClearSsoMicrosoftTenantIdValidators(set: boolean): void {
    try {
      if (!this.ssoForm)
        return;
      
      const setValidators: boolean=set &&
                                   this.showSingleSignOn &&
                                   this.requireSsoTenantIdMicrosoft;
      
      if (setValidators)
        this.ssoForm.get("ssoForm_ssoMicrosoftTenantId")?.setValidators([Validators.required, this.validatorService.guidValidator]);
      else
        this.ssoForm.get("ssoForm_ssoMicrosoftTenantId")?.clearValidators();
    
      this.ssoForm.get("ssoForm_ssoMicrosoftTenantId")?.updateValueAndValidity();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#endregion

  //#region Device Management

  //#region Microsoft Intune
  
  public mdmMicrosoftClick(): void {
    try {
      const mdmEnabled: boolean    =!this.mdmForm.get("mdmForm_mdmMicrosoft")?.value;
      this.mdmControlsShowMicrosoft=mdmEnabled;
      
      if (!mdmEnabled) {
        this.mdmForm.controls["mdmForm_mdmMicrosoftClientId"]    .setValue(undefined);
        this.mdmForm.controls["mdmForm_mdmMicrosoftClientSecret"].setValue(undefined);
        this.mdmForm.controls["mdmForm_mdmMicrosoftTenantId"]    .setValue(undefined);
      }

      this.setOrClearMdmMicrosoftValidators(mdmEnabled);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public setOrClearMdmMicrosoftValidators(set: boolean): void {
    try {
      if (!this.mdmForm)
        return;
      
      const setValidators: boolean=set && this.showDeviceManagement;
      
      if (setValidators) {
        this.mdmForm.get("mdmForm_mdmMicrosoftClientId")    ?.setValidators([Validators.required, this.validatorService.guidValidator]);
        this.mdmForm.get("mdmForm_mdmMicrosoftClientSecret")?.setValidators([Validators.required                                     ]);
        this.mdmForm.get("mdmForm_mdmMicrosoftTenantId")    ?.setValidators([Validators.required, this.validatorService.guidValidator]);

      } else {
        this.mdmForm.get("mdmForm_mdmMicrosoftClientId")    ?.clearValidators();
        this.mdmForm.get("mdmForm_mdmMicrosoftClientSecret")?.clearValidators();
        this.mdmForm.get("mdmForm_mdmMicrosoftTenantId")    ?.clearValidators();
      }
    
      this.mdmForm.get("mdmForm_mdmMicrosoftClientId")    ?.updateValueAndValidity();
      this.mdmForm.get("mdmForm_mdmMicrosoftClientSecret")?.updateValueAndValidity();
      this.mdmForm.get("mdmForm_mdmMicrosoftTenantId")    ?.updateValueAndValidity();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public canTestIntuneConnection(): boolean {
    try {
      const secret=this.mdmForm?.get("mdmForm_mdmMicrosoftClientSecret")?.value;
      
      if (!secret)
        return false;
      
      return secret===_MustMatchServerStrings.HiddenValue ||
             secret===_MustMatchServerStrings.HiddenValueCanOverwrite;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }
  
  public testIntuneConnection(): void {
    try {
      this.mdmIntuneService.canConnect(this.sureSimCompany?.id ?? -1)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.mdmTestConnectionResult=data.result;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#endregion

  //#region Licences
         
  public searchForVisibleLicences() {
    try {
      if (!this.visibleLicencesSearchFormIsOpen) {

        if (this.newCompany && !this.enableLicenceDetailsOnNew) {
          this.informationModalForm.openForm("Information", "Please save the company details before applying licences");
        
        } else {
          this.visibleLicencesSearchFormIsOpen=true;
          this.visibleLicencesSearchForm.openForm(this.sureSimCompany?.id);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
                 
  public visibleLicencesSearchFormHasBeenSaved() {
    try {
      this.visibleLicencesSearchFormIsOpen=false;
      this.licenceCards.refresh();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public visibleLicencesSearchFormCancelled() {
    try {
      this.visibleLicencesSearchFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Features
  
  public enableFeatures() {
    try {
      this.enableFeatureCountryPlans();
      this.enableFeatureLocationServices();
      this.enableFeatureLocationWebhook();
      this.enableFeatureMdm();
      this.enableFeatureSso();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public enableFeatureCountryPlans() {
    try {
      this.licencesCompanyAllocatedService.companyHasLicenceFeatureByGuid(this.sureSimCompany?.id, AccessGuids.ChargeableFeatureAlertsCountryPlans)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.featureEnabledCountryPlans=data.result;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public enableFeatureLocationServices() {
    try {
      this.licencesCompanyAllocatedService.companyHasLicenceFeatureByGuid(this.sureSimCompany?.id, AccessGuids.ChargeableFeatureLocationServices)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.featureEnabledLocationServices=data.result;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public enableFeatureLocationWebhook() {
    try {
      this.licencesCompanyAllocatedService.companyHasLicenceFeatureByGuid(this.sureSimCompany?.id, AccessGuids.ChargeableFeatureLocationWebhook)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.featureEnabledLocationWebhook=data.result;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async enableFeatureMdm(): Promise<void> {
    try {
      await this.mdmAccessService.ensureInitialised();

      if (this.mdmAccessService.isFeatureEnabled()) {
        this.featureEnabledMdm=true;
        return;
      }

      this.licencesCompanyAllocatedService.companyHasLicenceFeatureByGuid(this.sureSimCompany?.id, AccessGuids.ChargeableFeatureDeviceManagement)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.featureEnabledMdm=data.result;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public enableFeatureSso() {
    try {
      this.licencesCompanyAllocatedService.companyHasLicenceFeatureByGuid(this.sureSimCompany?.id, AccessGuids.ChargeableFeatureSingleSignOn)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.featureEnabledSso=data.result;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Navigation

  public onTabChange(event: NgbNavChangeEvent) {
    try {
      if (event.nextId == this.navItemSupport || event.nextId == this.navItemLocationServices) {
        this.companyModalFormRef.update({ size : msSize.ExtraLarge }); 
      } else {
        this.companyModalFormRef.update({ size : msSize.Large });        
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region System Lock
  
  private processSystemLock(): void {
    try {
      if (!this.systemLocksEnabled)
        return;

      const systemLock: SystemLockDTO={
        active    : true,
        enteredBy : this.curUser.userId,
        entityID  : this.sureSimCompanyId ?? -1,
        entityLock: SystemLocks.Company,
        id        : -1
      };
    
      this.systemLockService.entityIsLocked(systemLock)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          const possibleSystemLock: SystemLockDTO=data;

          if (possibleSystemLock.locked) {

            if (possibleSystemLock.sameUserLock) {
              this.systemLockId=possibleSystemLock.id;
            }
            else {
              this.formIsLocked       =true;
              this.lockedByAnotherUser=true;
              const lockDetail =`Company is being edited by\n\n${possibleSystemLock.enteredByName}\n\nas of ${this.datePipe.transform(possibleSystemLock.enteredDate, 'dd/MM/yyyy HH:mm:ss')}`;

              if (this.systemLocksShowDetails)
                this.fileLockHoverText=lockDetail;

              if (this.systemLocksShowWarningModal) {
                this.warningModalForm.openForm("WARNING",
                                               (<string>this.fileLockHoverText).replaceAll("\n", "<br>") + "<br><br>Changes are not permitted until the Edit is complete",
                                               "https://cdn.lordicon.com/fikcyfpp.json");
              }

              this.lockDownForm();
            }

          } else {
            this.lockEntity(systemLock);
          }
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private lockEntity(systemLock: SystemLockDTO): void {
    try {
      this.systemLockService.lockEntity(systemLock)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.systemLockId=data.id;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private unlockEntity(): void {
    try {
      if (!this.systemLocksEnabled || !this.systemLockId || this.systemLockId<0)
        return;

      this.systemLockService.unlockEntity(this.systemLockId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private lockDownForm(): void {
    try {
      this.basicDetailsForm.get("active")?.disable();
      this.basicDetailsForm.get("asCompanyAddress")?.disable();
      this.basicDetailsForm.get("companyTypeId")?.disable();
      this.basicDetailsForm.get("countryId")?.disable();
      this.basicDetailsForm.get("domain")?.disable();
      this.basicDetailsForm.get("regno")?.disable();
      this.basicDetailsForm.get("vatno")?.disable();

      this.invoiceDetailsForm.get("invoiceDetails_AccountRef")?.disable();
      this.invoiceDetailsForm.get("invoiceDetails_billFormat")?.disable();
      this.invoiceDetailsForm.get("invoiceDetails_creditLimit")?.disable();
      this.invoiceDetailsForm.get("invoiceDetails_creditLimitEnabled")?.disable();
      this.invoiceDetailsForm.get("invoiceDetails_creditLimitExceedAction")?.disable();
      this.invoiceDetailsForm.get("invoiceDetails_currentCreditLimit")?.disable();
      this.invoiceDetailsForm.get("invoiceDetails_CurrencyId")?.disable();
      this.invoiceDetailsForm.get("invoiceDetails_PaymentMethodId")?.disable();
      this.invoiceDetailsForm.get("invoiceDetails_PaymentTermId")?.disable();

      this.mdmForm.get("mdmForm_mdmDesensitise")?.disable();
      this.mdmForm.get("mdmForm_mdmMicrosoft")?.disable();
      this.mdmForm.get("mdmForm_mdmMicrosoftClientId")?.disable();
      this.mdmForm.get("mdmForm_mdmMicrosoftClientSecret")?.disable();
      this.mdmForm.get("mdmForm_mdmMicrosoftTenantId")?.disable();

      this.portalDetailsForm.get("portalDetails_Branding")?.disable();
      this.portalDetailsForm.get("portalDetails_CreateSubCompanies")?.disable();
      this.portalDetailsForm.get("portalDetails_PortalAccess")?.disable();

      this.ssoForm.get("ssoForm_ssoMicrosoft")?.disable();
      this.ssoForm.get("ssoForm_ssoMicrosoftTenantId")?.disable();

      this.usageLimitsForm.get("usageLimits_currencyId")?.disable();
      this.usageLimitsForm.get("usageLimits_dataLimit")?.disable();
      this.usageLimitsForm.get("usageLimits_limit")?.disable();
      this.usageLimitsForm.get("usageLimits_selfAuth")?.disable();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
